/* ==========================================================================
   THE UNFOLD ARC - INTERACTIVE ENGINE
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  
  /* --- Centralized Global Header Injection --- */
  const headerContainer = document.querySelector('.site-header');
  if (headerContainer && !document.body.hasAttribute('data-shopify-theme')) {
    headerContainer.innerHTML = `
      <div class="container header-container">
        <div class="brand-wrapper">
          <a href="index.html" class="brand-logo-link">
            <img src="assets/images/logo.webp" alt="The Unfold Arc Logo" style="max-height: 55px; width: auto; display: block;">
          </a>
        </div>
        
        <nav class="nav-links">
          <a href="shop.html" id="nav-shop">Shop</a>
          <div class="nav-item-dropdown">
            <a href="about.html" id="nav-the-arc" class="dropdown-trigger">The Arc <span class="arrow-icon">▼</span></a>
            <div class="dropdown-menu">
              <a href="about.html">Our Story</a>
              <a href="index.html#founders">Founders</a>
            </div>
          </div>
          <a href="impact.html" id="nav-impact">Impact</a>
          <a href="journal.html" id="nav-journal">Journal</a>
          <a href="contact.html" id="nav-community">Contact Us</a>
        </nav>
        
        <div class="header-actions">
          <!-- Account Login -->
          <a href="#" class="header-account-btn" aria-label="Sign In / Sign Up" onclick="event.preventDefault(); alert('Account login page simulated.');">
            <span>Sign In / Sign Up</span>
          </a>

          <button class="header-search-toggle" type="button" aria-label="Search">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </button>
          
          <div class="cart-toggle">
            <svg viewBox="0 0 24 24">
              <path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            <span class="cart-count">0</span>
          </div>
          
          <div class="mobile-menu-toggle">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    `;

    // Highlight active link based on current pathname and hash
    const updateActiveLinks = () => {
      const path = window.location.pathname;
      const page = path.substring(path.lastIndexOf('/') + 1) || 'index.html';
      const hash = window.location.hash;
      
      headerContainer.querySelectorAll('.nav-links a').forEach(link => link.classList.remove('active'));
      
      if (page === 'impact.html') {
        document.getElementById('nav-impact')?.classList.add('active');
      } else if (page === 'contact.html') {
        document.getElementById('nav-community')?.classList.add('active');
      } else if (page === 'journal.html') {
        document.getElementById('nav-journal')?.classList.add('active');
      } else if (page === 'about.html') {
        document.getElementById('nav-the-arc')?.classList.add('active');
      } else if (page === 'shop.html' || page.includes('product.html') || page.includes('new-arrivals.html')) {
        document.getElementById('nav-shop')?.classList.add('active');
      } else if (hash === '#impact') {
        document.getElementById('nav-impact')?.classList.add('active');
      } else if (hash === '#community') {
        document.getElementById('nav-community')?.classList.add('active');
      } else if (hash === '#philosophy' || hash === '#founders') {
        document.getElementById('nav-the-arc')?.classList.add('active');
      }
    };

    updateActiveLinks();
    window.addEventListener('hashchange', updateActiveLinks);
  }

  /* --- Smooth Hash Scroll Handler with Header Offset --- */
  const handleHashScroll = () => {
    const hash = window.location.hash;
    if (hash) {
      const targetEl = document.querySelector(hash);
      if (targetEl) {
        setTimeout(() => {
          const header = document.querySelector('.site-header');
          const headerOffset = header ? header.offsetHeight + 15 : 90;
          const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          // Reveal target section and child elements
          targetEl.classList.add('in-view');
          targetEl.querySelectorAll('.animate-on-scroll, .fade-up, .fade-in, .founders-image-container, .founders-content').forEach(child => {
            child.classList.add('in-view');
          });
        }, 120);
      }
    }
  };

  handleHashScroll();
  window.addEventListener('hashchange', handleHashScroll);

  // Global click interceptor for anchor links with hashes (e.g., #founders)
  document.addEventListener('click', (e) => {
    const anchor = e.target.closest('a[href*="#"]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    if (!href || href === '#') return;

    try {
      const url = new URL(href, window.location.href);
      if (url.pathname === window.location.pathname && url.hash) {
        const targetEl = document.querySelector(url.hash);
        if (targetEl) {
          e.preventDefault();
          window.history.pushState(null, '', url.hash);
          
          const header = document.querySelector('.site-header');
          const headerOffset = header ? header.offsetHeight + 15 : 90;
          const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });

          targetEl.classList.add('in-view');
          targetEl.querySelectorAll('.animate-on-scroll, .fade-up, .fade-in, .founders-image-container, .founders-content').forEach(child => {
            child.classList.add('in-view');
          });
        }
      }
    } catch (err) {
      // Ignore invalid URLs
    }
  });
  
  /* --- Shopify AJAX Cart --- */
  let cart = { items: [] };
  const SHOPIFY_CART = document.body.hasAttribute('data-shopify-theme');

  // Immediately load embedded cart data for zero-delay initial state
  const initialCartScript = document.getElementById('cart-drawer-initial-json') || document.getElementById('initial-cart-data');
  if (initialCartScript) {
    try {
      const parsedCart = JSON.parse(initialCartScript.textContent);
      if (parsedCart && typeof parsedCart === 'object') {
        cart = parsedCart;
      }
    } catch (e) {
      console.warn('Initial cart JSON parse error:', e);
    }
  }

  // Pending changes queue and debouncing timers per item
  const pendingChanges = {};
  const debounceTimers = {};
  let inFlightRequests = 0;
  
  // DOM Elements
  const cartToggle = document.querySelector('.cart-toggle');
  const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartClose = document.querySelector('.cart-close');
  const cartItemsContainer = document.querySelector('.cart-items');
  const cartCountBadges = document.querySelectorAll('.cart-count');
  const cartSubtotalPrice = document.querySelector('.cart-subtotal-price');
  
  /* --- Cart Drawer Functions --- */
  function openCart() {
    if (cartDrawerOverlay && cartDrawer) {
      cartDrawerOverlay.classList.add('open');
      cartDrawer.classList.add('open');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('cart-open');
      if (typeof syncCouponBoxes === 'function') {
        syncCouponBoxes();
      }
    }
  }

  function closeCart() {
    if (cartDrawerOverlay && cartDrawer) {
      cartDrawerOverlay.classList.remove('open');
      cartDrawer.classList.remove('open');
      document.body.style.overflow = '';
      document.body.classList.remove('cart-open');
    }
  }

  if (cartToggle) {
    cartToggle.addEventListener('click', openCart);
    cartToggle.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openCart();
      }
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCart);

  const moneyFmt = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'INR',
        maximumFractionDigits: 0
      }).format(cents / 100);
    } catch (e) {
      return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
    }
  };

  function shopUrl(path) {
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function updateCartBadges(totalCount, distinctCount) {
    cartCountBadges.forEach(badge => { badge.textContent = totalCount; });
    document.querySelectorAll('.main-cart-item-count .cart-count').forEach(el => { el.textContent = totalCount; });
    if (distinctCount !== undefined) {
      document.querySelectorAll('.cart-header-count').forEach(el => { el.textContent = distinctCount; });
    }
  }

  function updateCartSubtotals(cents) {
    const formatted = moneyFmt(cents);
    document.querySelectorAll('.cart-subtotal-price').forEach(el => {
      el.textContent = (cents === 0) ? '₹0' : formatted;
    });
  }

  function getEmptyDrawerHtml() {
    return `
      <div class="cart-empty">
        <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.2" style="margin: 0 auto 16px; color: var(--color-brand-burgundy); opacity: 0.6;">
          <path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
        <p>Your wardrobe is currently empty.</p>
        <a href="${shopUrl('/collections/all')}" class="btn btn-secondary" style="margin-top: 24px;">Explore Sustainable Staples</a>
      </div>`;
  }

  function getEmptyMainCartHtml() {
    return `
      <div class="main-cart-empty">
        <svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="currentColor" stroke-width="1.2" style="margin: 0 auto 20px; color: var(--color-brand-burgundy); opacity: 0.5;">
          <path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
        <h2>Your wardrobe is currently empty</h2>
        <p>Explore our organic cotton staples, polos, and crewnecks designed for everyday intention.</p>
        <a class="btn btn-primary" href="${shopUrl('/collections/all')}" style="margin-top:24px;display:inline-block;">Explore Collection</a>
      </div>`;
  }

  // Delegated real-time event listeners for instant click response (0ms delay)
  document.addEventListener('click', (e) => {
    // 1. Decrease quantity
    const minusBtn = e.target.closest('.qty-minus');
    if (minusBtn) {
      e.preventDefault();
      e.stopPropagation();
      const key = minusBtn.dataset.key || minusBtn.dataset.index;
      if (key !== undefined) adjustLine(key, -1);
      return;
    }

    // 2. Increase quantity
    const plusBtn = e.target.closest('.qty-plus');
    if (plusBtn) {
      e.preventDefault();
      e.stopPropagation();
      const key = plusBtn.dataset.key || plusBtn.dataset.index;
      if (key !== undefined) adjustLine(key, 1);
      return;
    }

    // 3. Remove line item
    const removeBtn = e.target.closest('.cart-item-remove, .main-cart-item-remove');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      const key = removeBtn.dataset.key || removeBtn.dataset.index;
      if (key !== undefined) changeLine(key, 0);
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      const minusBtn = e.target.closest('.qty-minus');
      if (minusBtn) {
        e.preventDefault();
        const key = minusBtn.dataset.key || minusBtn.dataset.index;
        if (key !== undefined) adjustLine(key, -1);
        return;
      }
      const plusBtn = e.target.closest('.qty-plus');
      if (plusBtn) {
        e.preventDefault();
        const key = plusBtn.dataset.key || plusBtn.dataset.index;
        if (key !== undefined) adjustLine(key, 1);
        return;
      }
    }
  });

  // Intercept cart page form submit for update button to avoid full page reload
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && form.classList.contains('main-cart-layout')) {
      const submitter = e.submitter;
      if (submitter && submitter.name === 'update') {
        e.preventDefault();
        const origText = submitter.textContent;
        submitter.textContent = 'Updated ✓';
        if (window.theme && typeof window.theme.refreshCart === 'function') {
          window.theme.refreshCart();
        }
        setTimeout(() => { submitter.textContent = origText; }, 1200);
      }
    }
  });

  function bindCartLineControls() {
    // Handled globally via delegated event listeners on document
  }

    function updateShippingProgress(subtotalCents) {
      // Free complimentary shipping is offered unconditionally
      return;
    }

    function formatVariantOptions(item) {
      if (!item) return '';
      if (item.product_has_only_default_variant || item.variant_title === 'Default Title') return '';

      // 1. Check options_with_values from Shopify API
      if (Array.isArray(item.options_with_values) && item.options_with_values.length > 0) {
        const valid = item.options_with_values.filter(opt => opt.value && opt.value !== 'Default Title');
        if (valid.length > 0) {
          return valid.map(opt => `<span class="cart-option-tag" style="display:inline-flex;gap:4px;margin-right:8px;"><span class="variant-label">${opt.name}:</span> <span class="variant-value">${opt.value}</span></span>`).join(' ');
        }
      }

      // 2. Check variant_options array
      if (Array.isArray(item.variant_options) && item.variant_options.length > 0) {
        const valid = item.variant_options.filter(v => v && v !== 'Default Title');
        if (valid.length > 0) {
          return valid.map(v => `<span class="variant-value" style="margin-right:6px;">${v}</span>`).join(' ');
        }
      }

      // 3. Fallback to variant_title or item.size / item.color
      if (item.variant_title && item.variant_title !== 'Default Title') {
        const parts = item.variant_title.split('/').map(p => p.trim()).filter(p => p !== 'Default Title');
        if (parts.length > 0) {
          return parts.map(p => `<span class="variant-value" style="margin-right:6px;">${p}</span>`).join(' ');
        }
      }
      if (item.size && item.size !== 'Default Title') {
        let str = `<span class="variant-label">Size:</span> <span class="variant-value">${item.size}</span>`;
        if (item.color) str += ` <span class="variant-label">Color:</span> <span class="variant-value">${item.color}</span>`;
        return str;
      }
      return '';
    }

    function renderMainCartPage(cartData) {
      const mainContent = document.getElementById('MainCartContent');
      if (!mainContent) return;
      const isShopifyData = Boolean(cartData && cartData.items);
      const items = isShopifyData ? cartData.items : cart;
      const totalItems = isShopifyData ? (cartData.item_count || 0) : cart.reduce((sum, item) => sum + item.quantity, 0);

      document.querySelectorAll('.main-cart-item-count .cart-count').forEach(el => el.textContent = totalItems);

      if (!items || items.length === 0) {
        mainContent.innerHTML = `
          <div class="main-cart-empty">
            <svg viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="currentColor" stroke-width="1.2" style="margin: 0 auto 20px; color: var(--color-brand-burgundy); opacity: 0.5;">
              <path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            <h2>Your wardrobe is currently empty</h2>
            <p>Explore our organic cotton staples, polos, and crewnecks designed for everyday intention.</p>
            <a class="btn btn-primary" href="${shopUrl('/collections/all')}" style="margin-top:24px;display:inline-block;">Explore Collection</a>
          </div>`;
        return;
      }

      let subtotalCents = 0;
      let itemsHtml = '';

      items.forEach((item, index) => {
        const key = isShopifyData ? item.key : index;
        const title = isShopifyData ? item.product_title : item.name;
        const img = isShopifyData ? item.image : item.image;
        const variantHtml = formatVariantOptions(item);
        const qty = item.quantity;
        let linePriceStr = '';
        if (isShopifyData) {
          linePriceStr = moneyFmt(item.final_line_price);
        } else {
          const num = parseInt(String(item.price).replace(/[^\d]/g, ''), 10);
          subtotalCents += (num * qty * 100);
          linePriceStr = `₹${(num * qty).toLocaleString('en-IN')}`;
        }
        const unitPriceStr = isShopifyData ? moneyFmt(item.final_price) : item.price;
        const itemUrl = isShopifyData ? item.url : 'shop.html';

        itemsHtml += `
          <div class="main-cart-item" data-key="${key}" data-index="${index}" data-price="${item.final_price || 0}" data-line-price="${item.final_line_price || 0}">
            <a href="${itemUrl}" class="main-cart-item-img-link">
              <img src="${img}" alt="${title}" class="main-cart-item-img">
            </a>
            <div class="main-cart-item-info">
              <h3 class="main-cart-item-title"><a href="${itemUrl}">${title}</a></h3>
              ${variantHtml ? `<div class="main-cart-item-variant">${variantHtml}</div>` : ''}
              <div class="main-cart-item-unit-price">${unitPriceStr}</div>
              <a href="#" class="main-cart-item-remove" data-key="${key}" data-index="${index}" aria-label="Remove ${title}">
                <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" style="margin-right:2px;display:inline-block;vertical-align:-1px;"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                <span>Remove</span>
              </a>
            </div>
            <div class="main-cart-item-qty-col">
              <div class="cart-item-qty">
                <span class="qty-btn qty-minus" data-key="${key}" data-index="${index}" role="button" tabindex="0" aria-label="Decrease quantity">−</span>
                <span class="qty-val">${qty}</span>
                <span class="qty-btn qty-plus" data-key="${key}" data-index="${index}" role="button" tabindex="0" aria-label="Increase quantity">+</span>
              </div>
            </div>
            <div class="main-cart-item-total-col">
              ${linePriceStr}
            </div>
          </div>`;
      });

      const totalFormatted = isShopifyData ? moneyFmt(cartData.total_price) : `₹${Math.round(subtotalCents / 100).toLocaleString('en-IN')}`;
      const isFreeShipping = isShopifyData ? (cartData.total_price >= 299900) : (subtotalCents >= 299900);

      mainContent.innerHTML = `
        <form action="${shopUrl('/cart')}" method="post" class="main-cart-layout">
          <div class="main-cart-items-column">
            <div class="main-cart-table-header">
              <span>Product Details</span>
              <span>Quantity</span>
              <span style="text-align:right;">Subtotal</span>
            </div>
            <div class="main-cart-items-list">
              ${itemsHtml}
            </div>
            <div class="main-cart-actions">
              <a href="${shopUrl('/collections/all')}" class="btn btn-secondary">← Continue Shopping</a>
            </div>
          </div>
          <div class="main-cart-summary-column">
            <div class="main-cart-summary-card">
              <div class="summary-header">
                <span class="summary-tag">PRICE DETAILS</span>
                <h3 class="summary-title">Order Summary</h3>
              </div>
              <div class="summary-row">
                <span>Subtotal</span>
                <span class="cart-subtotal-price">${totalFormatted}</span>
              </div>
              <div class="summary-row summary-shipping">
                <span>Shipping</span>
                <span class="summary-free-badge">FREE COMPLIMENTARY</span>
              </div>
              <!-- FIRST10 Promo Coupon Box -->
              <div class="cart-promo-coupon-box" data-coupon="FIRST10" role="region" aria-label="First Order Discount Promotion">
                <div class="cart-promo-left">
                  <div class="cart-promo-tag-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                      <line x1="7" y1="7" x2="7.01" y2="7"></line>
                    </svg>
                  </div>
                  <div class="cart-promo-info">
                    <div class="cart-promo-title-row">
                      <span class="cart-promo-title">10% OFF ON FIRST ORDER</span>
                    </div>
                    <div class="cart-promo-code-row">
                      <span class="cart-promo-code-label">Use code:</span>
                      <strong class="cart-promo-code">FIRST10</strong>
                    </div>
                  </div>
                </div>
                <button type="button" class="btn-cart-apply-coupon" data-coupon-code="FIRST10" aria-label="Apply discount code FIRST10">
                  <span class="coupon-action-text">APPLY</span>
                </button>
              </div>
              <!-- Cart Perks: No shipping charge & No minimum order value -->
              <div class="cart-perks-badge-row" style="margin: 14px 0; display: flex; flex-direction: column; gap: 8px;">
                <div class="cart-perk-pill">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                  <span>Zero shipping charge across India</span>
                </div>
                <div class="cart-perk-pill">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                  <span>No minimum order value required</span>
                </div>
              </div>
              <div class="summary-divider"></div>
              <div class="summary-row summary-total">
                <span>Estimated Total</span>
                <span class="cart-subtotal-price" style="font-size:1.45rem;color:var(--color-brand-burgundy,#691b1f);font-weight:700;">${totalFormatted}</span>
              </div>
              <p class="summary-note">Taxes included. All orders ship complimentary with live tracking dispatched from Mumbai.</p>
              <input type="hidden" name="checkout" value="1">
              <button type="submit" name="checkout" class="btn btn-primary cart-checkout-btn" style="width:100%;margin-top:16px;padding:15px;display:flex;align-items:center;justify-content:center;gap:8px;border:none;cursor:pointer;">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/></svg>
                <span>Initiate Secure Checkout →</span>
              </button>
            </div>
          </div>
        </form>
        <div class="cart-bottom-trust-section">
          <div class="cart-trust-row">
            <div class="cart-trust-item">
              <svg viewBox="0 0 24 24" class="cart-trust-icon"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>
              <div>
                <strong>100% Secure Checkout</strong>
                <p>Encrypted SSL payments via Razorpay, UPI & Cards</p>
              </div>
            </div>
            <div class="cart-trust-item">
              <svg viewBox="0 0 24 24" class="cart-trust-icon"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>
              <div>
                <strong>Hassle-Free Returns</strong>
                <p>Easy 7-day exchanges & returns on eligible items</p>
              </div>
            </div>
            <div class="cart-trust-item">
              <svg viewBox="0 0 24 24" class="cart-trust-icon"><path d="M2 22C2 12 10 4 22 2c0 10-8 18-20 20z" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M9 15l5-5" fill="none" stroke="currentColor" stroke-width="1.6"/></svg>
              <div>
                <strong>Certified Organic Cotton</strong>
                <p>Pure, low-impact organic fabrics made honestly layer by layer</p>
              </div>
            </div>
          </div>
          <div class="cart-brand-note-box">
            <h4>About The Unfold Arc</h4>
            <p>"Quietly refined. Thoughtfully made. Naturally aware." Each garment is engineered to endure beyond seasonal trends, supporting sustainable living and timeless everyday style.</p>
          </div>
        </div>`;
      if (typeof syncCouponBoxes === 'function') {
        syncCouponBoxes();
      }
    }

    function renderShopifyCart(data) {
      cart = data;
      const totalItems = data.item_count || 0;
      const distinctCount = (data.items && data.items.length) ? data.items.length : totalItems;
      updateCartBadges(totalItems, distinctCount);
      updateShippingProgress(data.total_price || 0);
      renderMainCartPage(data);

      if (!cartItemsContainer) return;
      const cartFooters = document.querySelectorAll('.cart-drawer .cart-footer');
      if (!data.items || data.items.length === 0) {
        cartFooters.forEach(f => { f.style.display = 'none'; });
        updateCartSubtotals(0);
        cartItemsContainer.innerHTML = getEmptyDrawerHtml();
        document.querySelectorAll('.cart-checkout-btn').forEach(btn => {
          btn.disabled = true;
          btn.setAttribute('disabled', 'disabled');
        });
        return;
      }

      cartFooters.forEach(f => { f.style.display = 'block'; });
      if (typeof syncCouponBoxes === 'function') {
        syncCouponBoxes();
      }
      document.querySelectorAll('.cart-checkout-btn').forEach(btn => {
        btn.disabled = false;
        btn.removeAttribute('disabled');
      });
      let html = '';
      data.items.forEach((item) => {
        const variantHtml = formatVariantOptions(item);
        html += `
          <div class="cart-item" data-key="${item.key}" data-price="${item.final_price}" data-line-price="${item.final_line_price}">
            <img src="${item.image}" alt="${item.product_title}" class="cart-item-img">
            <div class="cart-item-details">
              <h4 class="cart-item-title">${item.product_title}</h4>
              ${variantHtml ? `<div class="cart-item-meta">${variantHtml}</div>` : ''}
              <div class="cart-item-qty">
                <span class="qty-btn qty-minus" data-key="${item.key}" role="button" tabindex="0" aria-label="Decrease quantity">−</span>
                <span class="qty-val">${item.quantity}</span>
                <span class="qty-btn qty-plus" data-key="${item.key}" role="button" tabindex="0" aria-label="Increase quantity">+</span>
              </div>
            </div>
            <div class="cart-item-price-col">
              <div class="cart-item-price">${moneyFmt(item.final_line_price)}</div>
              <a href="#" class="cart-item-remove" data-key="${item.key}" aria-label="Remove item">Remove</a>
            </div>
          </div>`;
      });
      cartItemsContainer.innerHTML = html;
      updateCartSubtotals(data.items_subtotal_price || data.total_price);
    }

    // In-place reconciliation without destroying DOM nodes during rapid user actions
    function reconcileShopifyCart(data) {
      cart = data;
      const totalItems = data.item_count || 0;
      const distinctCount = (data.items && data.items.length) ? data.items.length : totalItems;

      updateCartBadges(totalItems, distinctCount);
      updateShippingProgress(data.total_price || 0);

      const cartFooters = document.querySelectorAll('.cart-drawer .cart-footer');
      if (totalItems === 0 || !data.items || data.items.length === 0) {
        cartFooters.forEach(f => { f.style.display = 'none'; });
        updateCartSubtotals(0);
        if (cartItemsContainer) {
          cartItemsContainer.innerHTML = getEmptyDrawerHtml();
        }
        const mainContent = document.getElementById('MainCartContent');
        if (mainContent) {
          mainContent.innerHTML = getEmptyMainCartHtml();
        }
        document.querySelectorAll('.cart-checkout-btn').forEach(btn => {
          btn.disabled = true;
          btn.setAttribute('disabled', 'disabled');
        });
        closeCart();
        return;
      }

      cartFooters.forEach(f => { f.style.display = 'block'; });
      document.querySelectorAll('.cart-checkout-btn').forEach(btn => {
        btn.disabled = false;
        btn.removeAttribute('disabled');
      });
      updateCartSubtotals(data.items_subtotal_price || data.total_price);

      const serverMap = new Map();
      data.items.forEach(item => {
        serverMap.set(String(item.key), item);
      });

      // Reconcile Cart Drawer items
      const drawerItems = document.querySelectorAll('.cart-drawer .cart-item');
      let drawerMismatch = false;
      drawerItems.forEach(el => {
        const key = el.dataset.key;
        if (!serverMap.has(key)) {
          el.remove();
        } else {
          const item = serverMap.get(key);
          el.dataset.price = item.final_price;
          el.dataset.linePrice = item.final_line_price;
          if (pendingChanges[key] === undefined) {
            const qtyVal = el.querySelector('.qty-val');
            if (qtyVal && qtyVal.textContent.trim() !== String(item.quantity)) {
              qtyVal.textContent = item.quantity;
            }
          }
          const priceEl = el.querySelector('.cart-item-price');
          if (priceEl) {
            priceEl.textContent = moneyFmt(item.final_line_price);
          }
        }
      });
      if (data.items.length !== document.querySelectorAll('.cart-drawer .cart-item').length) {
        drawerMismatch = true;
      }
      if (drawerMismatch) {
        renderShopifyCart(data);
        return;
      }

      // Reconcile Main Cart items
      const mainCartItems = document.querySelectorAll('.main-cart-item');
      if (mainCartItems.length > 0) {
        let mainMismatch = false;
        mainCartItems.forEach(el => {
          const key = el.dataset.key;
          if (!serverMap.has(key)) {
            el.remove();
          } else {
            const item = serverMap.get(key);
            el.dataset.price = item.final_price;
            el.dataset.linePrice = item.final_line_price;
            if (pendingChanges[key] === undefined) {
              const qtyVal = el.querySelector('.qty-val');
              if (qtyVal && qtyVal.textContent.trim() !== String(item.quantity)) {
                qtyVal.textContent = item.quantity;
              }
            }
            const totalCol = el.querySelector('.main-cart-item-total-col');
            if (totalCol) {
              totalCol.textContent = moneyFmt(item.final_line_price);
            }
          }
        });
        if (data.items.length !== document.querySelectorAll('.main-cart-item').length) {
          mainMismatch = true;
        }
        if (mainMismatch) {
          renderMainCartPage(data);
        }
      }
    }

    function renderLocalCart() {
      const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
      cartCountBadges.forEach(badge => { badge.textContent = totalItems; });
      document.querySelectorAll('.cart-header-count').forEach(el => { el.textContent = cart.length; });
      renderMainCartPage(null);
      if (!cartItemsContainer) return;
      const cartFooters = document.querySelectorAll('.cart-drawer .cart-footer');
      if (cart.length === 0) {
        cartFooters.forEach(f => { f.style.display = 'none'; });
        document.querySelectorAll('.cart-subtotal-price').forEach(el => {
          el.textContent = '₹0';
        });
        updateShippingProgress(0);
        cartItemsContainer.innerHTML = `
          <div class="cart-empty">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.2" style="margin: 0 auto 16px; color: var(--color-brand-burgundy); opacity: 0.6;">
              <path d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            <p>Your wardrobe is currently empty.</p>
            <a href="shop.html" class="btn btn-secondary" style="margin-top: 24px;">Explore Sustainable Staples</a>
          </div>`;
        document.querySelectorAll('.cart-checkout-btn').forEach(btn => {
          btn.disabled = true;
          btn.setAttribute('disabled', 'disabled');
        });
        return;
      }
      cartFooters.forEach(f => { f.style.display = 'block'; });
      document.querySelectorAll('.cart-checkout-btn').forEach(btn => {
        btn.disabled = false;
        btn.removeAttribute('disabled');
      });
      let html = '';
      let subtotal = 0;
      cart.forEach((item, index) => {
        const priceNum = parseInt(String(item.price).replace(/[^\d]/g, ''), 10);
        const itemSubtotal = priceNum * item.quantity;
        subtotal += itemSubtotal;
        const variantHtml = formatVariantOptions(item);
        html += `
          <div class="cart-item" data-index="${index}">
            <img src="${item.image}" alt="${item.name}" class="cart-item-img">
            <div class="cart-item-details">
              <h4 class="cart-item-title">${item.name}</h4>
              ${variantHtml ? `<div class="cart-item-meta">${variantHtml}</div>` : ''}
              <div class="cart-item-qty">
                <span class="qty-btn qty-minus" data-index="${index}" role="button" tabindex="0">−</span>
                <span class="qty-val">${item.quantity}</span>
                <span class="qty-btn qty-plus" data-index="${index}" role="button" tabindex="0">+</span>
              </div>
            </div>
            <div class="cart-item-price-col">
              <div class="cart-item-price">₹${itemSubtotal.toLocaleString('en-IN')}</div>
              <a href="#" class="cart-item-remove" data-index="${index}">Remove</a>
            </div>
          </div>`;
      });
      cartItemsContainer.innerHTML = html;
      document.querySelectorAll('.cart-subtotal-price').forEach(el => {
        el.textContent = '₹' + subtotal.toLocaleString('en-IN');
      });
      updateShippingProgress(subtotal * 100);
    }

  async function refreshCart() {
    if (!SHOPIFY_CART) {
      renderLocalCart();
      return;
    }
    try {
      const res = await fetch(shopUrl('/cart.js'));
      const data = await res.json();
      renderShopifyCart(data);
    } catch (e) {
      console.warn('Cart refresh failed:', e);
    }
  }

  // Instant optimistic updates (0ms) + debounced server synchronization (250ms)
  function adjustLine(key, change) {
    if (key === undefined || key === null || key === '') return;

    let currentQty = 0;
    let itemObj = null;

    if (SHOPIFY_CART) {
      if (cart && Array.isArray(cart.items)) {
        itemObj = cart.items.find(i => String(i.key) === String(key) || String(i.id) === String(key));
        if (itemObj) currentQty = itemObj.quantity;
      }
      if (pendingChanges[key] !== undefined) {
        currentQty = pendingChanges[key];
      } else if (currentQty === 0) {
        const domEl = document.querySelector(`.cart-item[data-key="${key}"], .main-cart-item[data-key="${key}"]`);
        if (domEl) {
          const valEl = domEl.querySelector('.qty-val');
          if (valEl) currentQty = parseInt(valEl.textContent.trim(), 10) || 1;
        }
      }
      const nextQty = Math.max(0, currentQty + change);
      if (nextQty === currentQty) return;
      changeLine(key, nextQty);
      return;
    }

    // Local cart fallback
    const index = Number(key);
    if (cart[index]) {
      cart[index].quantity += change;
      if (cart[index].quantity <= 0) cart.splice(index, 1);
    }
    renderLocalCart();
    if (cart.length === 0) closeCart();
  }

  function changeLine(key, targetQty) {
    if (key === undefined || key === null || key === '') return;

    if (!SHOPIFY_CART) {
      const index = Number(key);
      if (cart[index]) {
        cart[index].quantity = targetQty;
        if (cart[index].quantity <= 0) cart.splice(index, 1);
      }
      renderLocalCart();
      if (cart.length === 0) closeCart();
      return;
    }

    targetQty = Math.max(0, parseInt(targetQty, 10) || 0);
    pendingChanges[key] = targetQty;

    let unitPrice = 0;
    let itemObj = null;
    if (cart && Array.isArray(cart.items)) {
      itemObj = cart.items.find(i => String(i.key) === String(key) || String(i.id) === String(key));
      if (itemObj) {
        unitPrice = itemObj.final_price || itemObj.price || 0;
      }
    }
    const matchingElements = document.querySelectorAll(`.cart-item[data-key="${key}"], .main-cart-item[data-key="${key}"]`);
    if (!unitPrice && matchingElements.length > 0) {
      unitPrice = parseInt(matchingElements[0].dataset.price, 10) || 0;
    }

    if (targetQty === 0) {
      // 1. Optimistic removal feedback
      matchingElements.forEach(el => {
        el.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
        el.style.opacity = '0.3';
        el.style.pointerEvents = 'none';
      });

      if (itemObj) {
        itemObj.quantity = 0;
        itemObj.final_line_price = 0;
      }

      // Check remaining items across cart
      const remainingItems = (cart.items || []).filter(i => String(i.key) !== String(key) && i.quantity > 0);
      const remainingTotalCount = remainingItems.reduce((sum, i) => sum + i.quantity, 0);

      if (remainingTotalCount === 0) {
        // Immediate close and empty state
        closeCart();
        updateCartBadges(0, 0);
        updateCartSubtotals(0);
        const cartFooters = document.querySelectorAll('.cart-drawer .cart-footer');
        cartFooters.forEach(f => { f.style.display = 'none'; });
        if (cartItemsContainer) {
          cartItemsContainer.innerHTML = getEmptyDrawerHtml();
        }
        const mainContent = document.getElementById('MainCartContent');
        if (mainContent) {
          mainContent.innerHTML = getEmptyMainCartHtml();
        }
      } else {
        const newTotalCents = remainingItems.reduce((sum, i) => sum + (i.final_line_price || ((i.final_price || i.price) * i.quantity)), 0);
        updateCartBadges(remainingTotalCount, remainingItems.length);
        updateCartSubtotals(newTotalCents);
      }

      // Immediate server call for removal (no debounce needed for remove)
      clearTimeout(debounceTimers[key]);
      delete debounceTimers[key];
      syncServerCartChange(key, 0);
      return;
    }

    // targetQty > 0:
    // 1. INSTANT (0ms) DOM update for line items
    const newLinePrice = unitPrice * targetQty;
    matchingElements.forEach(el => {
      const valEl = el.querySelector('.qty-val');
      if (valEl) valEl.textContent = targetQty;

      const priceEl = el.querySelector('.cart-item-price');
      if (priceEl && unitPrice > 0) {
        priceEl.textContent = moneyFmt(newLinePrice);
      }

      const totalCol = el.querySelector('.main-cart-item-total-col');
      if (totalCol && unitPrice > 0) {
        totalCol.textContent = moneyFmt(newLinePrice);
      }
    });

    // 2. In-memory update
    if (itemObj) {
      itemObj.quantity = targetQty;
      itemObj.final_line_price = newLinePrice;
    }

    // 3. Recalculate totals across cart
    let totalCents = 0;
    let totalItemsCount = 0;
    let distinctCount = 0;
    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(i => {
        if (i.quantity > 0) {
          totalCents += (i.final_line_price || ((i.final_price || i.price) * i.quantity));
          totalItemsCount += i.quantity;
          distinctCount++;
        }
      });
    }
    updateCartBadges(totalItemsCount, distinctCount);
    updateCartSubtotals(totalCents);

    // 4. Debounce network sync by 250ms
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(() => {
      delete debounceTimers[key];
      const finalQty = pendingChanges[key];
      syncServerCartChange(key, finalQty);
    }, 250);
  }

  async function syncServerCartChange(key, quantity) {
    inFlightRequests++;
    try {
      const res = await fetch(shopUrl('/cart/change.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const data = await res.json();

      // If user clicked again while in-flight, trigger newest pending quantity
      if (pendingChanges[key] !== undefined && pendingChanges[key] !== quantity) {
        const newestQty = pendingChanges[key];
        syncServerCartChange(key, newestQty);
        return;
      }

      delete pendingChanges[key];

      if (!data.items || data.items.length === 0 || data.item_count === 0) {
        renderShopifyCart(data);
        closeCart();
      } else {
        reconcileShopifyCart(data);
      }
    } catch (err) {
      console.warn('Cart change network error:', err);
      delete pendingChanges[key];
      refreshCart();
    } finally {
      inFlightRequests = Math.max(0, inFlightRequests - 1);
    }
  }

  function updateCart() {
    refreshCart();
  }

  refreshCart();

  async function addToCart(product) {
    // 1. Open cart drawer instantly on the spot for zero-delay response
    openCart();

    if (SHOPIFY_CART) {
      const variantId = product.variantId || product.id;
      try {
        await fetch(shopUrl('/cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: product.quantity || 1 })
        });

        // Meta Pixel AddToCart tracking with multi-format catalogue IDs
        if (typeof window.fbq === 'function') {
          const vId = String(variantId);
          const pId = String(product.productId || product.product_id || '');
          const priceVal = parseFloat(String(product.price || 0).replace(/[^\d.]/g, '')) || 0;
          const contentIds = [vId];
          if (pId) {
            contentIds.push(`shopify_IN_${pId}_${vId}`, `shopify_${pId}_${vId}`, pId);
          }
          window.fbq('track', 'AddToCart', {
            content_name: product.name || product.title || '',
            content_ids: contentIds,
            content_type: 'product',
            value: priceVal * (product.quantity || 1),
            currency: window.Shopify?.currency?.active || 'INR'
          });
        }
      } catch (err) {
        console.warn('Cart add network error:', err);
      }
      refreshCart();
      return;
    }
    const existingIndex = cart.findIndex(item => item.id === product.id && item.size === product.size);
    if (existingIndex > -1) cart[existingIndex].quantity += product.quantity;
    else cart.push(product);
    renderLocalCart();
  }

  window.theme = window.theme || {};
  window.theme.openCart = openCart;
  window.theme.closeCart = closeCart;
  window.theme.refreshCart = refreshCart;
  window.theme.adjustLine = adjustLine;
  window.theme.changeLine = changeLine;
  window.theme.renderShopifyCart = renderShopifyCart;
  window.theme.reconcileShopifyCart = reconcileShopifyCart;
  window.theme.moneyFmt = moneyFmt;
  window.theme.shopUrl = shopUrl;
  window.theme.addToCart = addToCart;
  window.renderShopifyCart = renderShopifyCart;

  document.querySelectorAll('.btn-add-to-cart').forEach(btn => {
    btn.addEventListener('click', (e) => {
      if (btn.closest('.product-page-section') || btn.closest('.product-detail-grid')) return;
      e.preventDefault();
      const card = e.target.closest('[data-product-id]') || document.querySelector('[data-product-id]');
      if (!card) return;
      let variantId = card.dataset.productId;
      const sizeBtn = card.querySelector('.size-btn.active') || card.querySelector('.size-tile-btn.active');
      const sizeSelect = card.querySelector('.size-select');
      let size = 'M';
      if (sizeBtn) {
        variantId = sizeBtn.dataset.variantId || variantId;
        const nameSpan = sizeBtn.querySelector('.size-name');
        size = nameSpan ? nameSpan.textContent.trim() : sizeBtn.textContent.trim();
      } else if (sizeSelect) {
        variantId = sizeSelect.value;
        size = sizeSelect.options[sizeSelect.selectedIndex]?.text || sizeSelect.value;
      }
      let quantity = 1;
      const qtyVal = card.querySelector('.qty-val') || card.querySelector('.product-qty-val');
      if (qtyVal) quantity = parseInt(qtyVal.textContent, 10) || 1;
      addToCart({
        id: variantId,
        variantId,
        name: card.dataset.productName,
        price: card.dataset.productPrice,
        size,
        quantity,
        image: card.dataset.productImage
      });
    });
  });

  /* --- Cart Discount Coupon (FIRST10) System --- */
  function syncCouponBoxes() {
    const appliedCode = sessionStorage.getItem('tua_applied_discount');
    const boxes = document.querySelectorAll('.cart-promo-coupon-box');
    boxes.forEach(box => {
      const code = box.dataset.coupon || 'FIRST10';
      const isApplied = (appliedCode === code);
      const btn = box.querySelector('.btn-cart-apply-coupon');
      const actionText = btn ? btn.querySelector('.coupon-action-text') : null;
      if (isApplied) {
        box.classList.add('is-applied');
        if (btn) {
          btn.classList.add('applied');
          btn.setAttribute('aria-label', `Discount ${code} applied`);
        }
        if (actionText) actionText.textContent = 'APPLIED ✓';
      } else {
        box.classList.remove('is-applied');
        if (btn) {
          btn.classList.remove('applied');
          btn.setAttribute('aria-label', `Apply discount ${code}`);
        }
        if (actionText) actionText.textContent = 'APPLY';
      }
    });

    // Ensure all cart checkout forms have the discount input if applied
    document.querySelectorAll('form[action*="/cart"]').forEach(form => {
      let discountInput = form.querySelector('input[name="discount"]');
      if (appliedCode) {
        if (!discountInput) {
          discountInput = document.createElement('input');
          discountInput.type = 'hidden';
          discountInput.name = 'discount';
          form.appendChild(discountInput);
        }
        discountInput.value = appliedCode;
      } else if (discountInput) {
        discountInput.remove();
      }
    });
  }

  function showPromoToast(message) {
    let toast = document.getElementById('cart-promo-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'cart-promo-toast';
      toast.className = 'cart-promo-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2800);
  }

  document.addEventListener('click', (e) => {
    const applyBtn = e.target.closest('.btn-cart-apply-coupon');
    const couponBox = e.target.closest('.cart-promo-coupon-box');
    if (!applyBtn && !couponBox) return;

    e.preventDefault();
    e.stopPropagation();

    const targetBox = couponBox || (applyBtn && applyBtn.closest('.cart-promo-coupon-box'));
    const code = (targetBox && targetBox.dataset.coupon) || (applyBtn && applyBtn.dataset.couponCode) || 'FIRST10';
    const currentApplied = sessionStorage.getItem('tua_applied_discount');

    if (currentApplied === code) {
      sessionStorage.removeItem('tua_applied_discount');
      syncCouponBoxes();
      showPromoToast(`Discount ${code} removed`);
    } else {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).catch(() => {});
        }
      } catch (_) {}
      sessionStorage.setItem('tua_applied_discount', code);
      syncCouponBoxes();
      showPromoToast(`Code ${code} applied to checkout!`);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCouponBoxes);
  } else {
    syncCouponBoxes();
  }

  // Centralized Checkout Button Delegator
  document.addEventListener('click', async (e) => {
    const checkoutBtn = e.target.closest('.cart-checkout-btn');
    if (!checkoutBtn) return;

    // Ignore if button is explicitly disabled or cart is empty
    if (checkoutBtn.hasAttribute('disabled') || checkoutBtn.disabled) {
      e.preventDefault();
      return;
    }

    const appliedDiscount = sessionStorage.getItem('tua_applied_discount');

    if (!SHOPIFY_CART) {
      e.preventDefault();
      const checkoutUrl = appliedDiscount ? shopUrl(`/checkout?discount=${encodeURIComponent(appliedDiscount)}`) : shopUrl('/checkout');
      window.location.href = checkoutUrl;
      return;
    }

    // Meta Pixel InitiateCheckout tracking with multi-format catalogue IDs
    if (typeof window.fbq === 'function' && cart) {
      const items = cart.items || [];
      const contentIds = [];
      items.forEach(item => {
        const vId = String(item.variant_id || item.id || '');
        const pId = String(item.product_id || '');
        if (vId) {
          contentIds.push(vId);
          if (pId) {
            contentIds.push(`shopify_IN_${pId}_${vId}`, `shopify_${pId}_${vId}`, pId);
          }
        }
      });
      window.fbq('track', 'InitiateCheckout', {
        content_ids: contentIds,
        content_type: 'product',
        value: (cart.total_price || 0) / 100,
        currency: window.Shopify?.currency?.active || 'INR',
        num_items: cart.item_count || 0
      });
    }

    const pendingKeys = Object.keys(pendingChanges);
    const hasPending = pendingKeys.length > 0 || inFlightRequests > 0;

    // If there are pending optimistic updates waiting to sync to Shopify
    if (hasPending) {
      e.preventDefault();

      const originalText = checkoutBtn.innerHTML;
      checkoutBtn.disabled = true;
      checkoutBtn.style.opacity = '0.7';

      // Cancel any active debounce timers
      Object.keys(debounceTimers).forEach(k => {
        clearTimeout(debounceTimers[k]);
        delete debounceTimers[k];
      });

      // Synchronize pending quantities immediately
      if (pendingKeys.length > 0) {
        try {
          const updates = {};
          pendingKeys.forEach(k => {
            updates[k] = pendingChanges[k];
          });
          await fetch(shopUrl('/cart/update.js'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates })
          });
          pendingKeys.forEach(k => delete pendingChanges[k]);
        } catch (err) {
          console.warn('Failed to flush cart changes before checkout:', err);
        }
      }

      // Wait briefly for any in-flight requests to complete
      let waitCount = 0;
      while (inFlightRequests > 0 && waitCount < 10) {
        await new Promise(res => setTimeout(res, 100));
        waitCount++;
      }

      checkoutBtn.disabled = false;
      checkoutBtn.style.opacity = '';
      checkoutBtn.innerHTML = originalText;

      const parentForm = checkoutBtn.closest('form');
      if (parentForm) {
        if (appliedDiscount) {
          let discountInput = parentForm.querySelector('input[name="discount"]');
          if (!discountInput) {
            discountInput = document.createElement('input');
            discountInput.type = 'hidden';
            discountInput.name = 'discount';
            parentForm.appendChild(discountInput);
          }
          discountInput.value = appliedDiscount;
        }
        if (!parentForm.querySelector('input[name="checkout"]')) {
          const hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'checkout';
          hiddenInput.value = '1';
          parentForm.appendChild(hiddenInput);
        }
        if (typeof parentForm.requestSubmit === 'function') {
          parentForm.requestSubmit(checkoutBtn);
        } else {
          parentForm.submit();
        }
      } else {
        const checkoutUrl = appliedDiscount ? shopUrl(`/checkout?discount=${encodeURIComponent(appliedDiscount)}`) : shopUrl('/checkout');
        window.location.href = checkoutUrl;
      }
      return;
    }

    // When there are NO pending debounced changes:
    const parentForm = checkoutBtn.closest('form');
    if (parentForm) {
      if (appliedDiscount) {
        let discountInput = parentForm.querySelector('input[name="discount"]');
        if (!discountInput) {
          discountInput = document.createElement('input');
          discountInput.type = 'hidden';
          discountInput.name = 'discount';
          parentForm.appendChild(discountInput);
        }
        discountInput.value = appliedDiscount;
      }
      if (!parentForm.querySelector('input[name="checkout"]')) {
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'checkout';
        hiddenInput.value = '1';
        parentForm.appendChild(hiddenInput);
      }
      // Allow the native form submit event to proceed without e.preventDefault()!
      // This guarantees Razorpay COD Magic Checkout and native Shopify checkout both execute smoothly.
    } else {
      e.preventDefault();
      const checkoutUrl = appliedDiscount ? shopUrl(`/checkout?discount=${encodeURIComponent(appliedDiscount)}`) : shopUrl('/checkout');
      window.location.href = checkoutUrl;
    }
  });

  /* --- Header & Announcement Scroll Effect --- */
  const header = document.querySelector('.site-header');
  const notificationBarEl = document.getElementById('NotificationBar');

  window.addEventListener('scroll', () => {
    const isScrolled = window.scrollY > 50;
    if (header) {
      if (isScrolled) {
        header.classList.add('header-scrolled');
      } else {
        header.classList.remove('header-scrolled');
      }
    }
    if (notificationBarEl) {
      if (isScrolled) {
        notificationBarEl.classList.add('announcement-scrolled');
      } else {
        notificationBarEl.classList.remove('announcement-scrolled');
      }
    }
  }, { passive: true });

  /* --- Mobile Navigation Drawer --- */
  const mobileToggle = document.querySelector('.mobile-menu-toggle');
  const mobileDrawer = document.getElementById('MobileNavDrawer');
  const mobileOverlay = document.querySelector('.mobile-nav-overlay');
  const mobileCloseBtn = document.querySelector('.mobile-nav-close-btn');

  const setMobileMenuOpen = (open) => {
    if (!mobileDrawer || !mobileToggle) return;
    mobileDrawer.classList.toggle('is-open', open);
    if (mobileOverlay) {
      mobileOverlay.classList.toggle('is-open', open);
    }
    mobileToggle.classList.toggle('is-open', open);
    mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    mobileToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.classList.toggle('nav-open', open);
  };

  if (mobileToggle && mobileDrawer) {
    mobileToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setMobileMenuOpen(!mobileDrawer.classList.contains('is-open'));
    });

    if (mobileCloseBtn) {
      mobileCloseBtn.addEventListener('click', (e) => {
        e.preventDefault();
        setMobileMenuOpen(false);
      });
    }

    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', () => setMobileMenuOpen(false));
    }

    mobileDrawer.querySelectorAll('.mobile-nav-expander').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        const parentItem = btn.closest('.mobile-nav-item--parent');
        const siblingExpanders = parentItem && parentItem.parentElement
          ? parentItem.parentElement.querySelectorAll(':scope > .mobile-nav-item--parent > .mobile-nav-parent > .mobile-nav-expander')
          : [];
        siblingExpanders.forEach((other) => {
          if (other === btn) return;
          other.setAttribute('aria-expanded', 'false');
          const otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) {
            otherPanel.classList.remove('is-open');
          }
        });
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) {
          panel.classList.toggle('is-open', !expanded);
        }
      });
    });

    mobileDrawer.querySelectorAll('.mobile-nav-link, .mobile-nav-sublink, .mobile-nav-user-heading, .mobile-nav-login-link').forEach((link) => {
      link.addEventListener('click', () => setMobileMenuOpen(false));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileDrawer.classList.contains('is-open')) {
        setMobileMenuOpen(false);
        mobileToggle.focus();
      }
    });
  }

  /* --- Notification / Announcement Bar Slider --- */
  const notificationBar = document.getElementById('NotificationBar');
  if (notificationBar) {
    const slides = notificationBar.querySelectorAll('.announcement-slide');
    const dismissBtn = document.getElementById('DismissNotificationBtn');
    const speed = parseInt(notificationBar.dataset.autoplaySpeed, 10) || 4000;

    if (sessionStorage.getItem('tua_notification_dismissed') === 'true') {
      notificationBar.classList.add('is-dismissed');
      document.body.style.setProperty('--announcement-height', '0px');
    } else if (dismissBtn) {
      dismissBtn.addEventListener('click', () => {
        notificationBar.classList.add('is-dismissed');
        sessionStorage.setItem('tua_notification_dismissed', 'true');
        document.body.style.setProperty('--announcement-height', '0px');
      });
    }

    if (slides.length > 1) {
      let currentSlide = 0;
      setInterval(() => {
        slides[currentSlide].classList.remove('is-active');
        currentSlide = (currentSlide + 1) % slides.length;
        slides[currentSlide].classList.add('is-active');
      }, speed);
    }

    // 1-Click Announcement Coupon Code Copy
    notificationBar.addEventListener('click', (e) => {
      const chip = e.target.closest('.announcement-coupon-chip');
      if (!chip) return;
      e.preventDefault();
      e.stopPropagation();
      const code = chip.dataset.copyCoupon;
      if (!code) return;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(() => {
          const origCode = chip.querySelector('.chip-code') ? chip.querySelector('.chip-code').textContent : code;
          chip.classList.add('is-copied');
          chip.innerHTML = `<span class="chip-code">${origCode}</span><span class="chip-action">COPIED!</span>`;
          setTimeout(() => {
            chip.classList.remove('is-copied');
            chip.innerHTML = `<span class="chip-code">${origCode}</span><span class="chip-action">COPY</span>`;
          }, 2400);
        }).catch(() => {});
      }
    });
  }

  /* --- Section 4: Why We Do Things Differently Carousel --- */
  const diffDots = document.querySelectorAll('.diff-dot');
  const diffSlides = document.querySelectorAll('.diff-slide');
  let diffIndex = 0;
  let diffInterval;

  function showDiffSlide(index) {
    diffSlides.forEach(slide => slide.classList.remove('active'));
    diffDots.forEach(dot => dot.classList.remove('active'));
    
    diffSlides[index].classList.add('active');
    diffDots[index].classList.add('active');
    diffIndex = index;
  }

  if (diffDots.length > 0 && diffSlides.length > 0) {
    diffDots.forEach(dot => {
      dot.addEventListener('click', (e) => {
        clearInterval(diffInterval);
        showDiffSlide(parseInt(e.target.dataset.index, 10));
        startDiffAutoplay();
      });
    });

    function startDiffAutoplay() {
      diffInterval = setInterval(() => {
        let nextIndex = (diffIndex + 1) % diffSlides.length;
        showDiffSlide(nextIndex);
      }, 5000);
    }
    
    startDiffAutoplay();
  }

  /* --- FAQ Accordion --- */
  function handleFaqClick(e) {
    e.preventDefault();
    const q = e.currentTarget;
    const item = q.closest('.faq-item');
    if (!item) return;
    const content = item.querySelector('.faq-answer');
    const isActive = item.classList.contains('active');

    // Find parent group to close sibling items
    const parentContainer = item.closest('.faq-accordion') || item.closest('.faq-list') || item.parentElement;
    if (parentContainer) {
      parentContainer.querySelectorAll('.faq-item').forEach(faq => {
        if (faq !== item) {
          faq.classList.remove('active');
          const ans = faq.querySelector('.faq-answer');
          if (ans) ans.style.maxHeight = null;
        }
      });
    }

    // Toggle clicked item
    if (isActive) {
      item.classList.remove('active');
      if (content) content.style.maxHeight = null;
    } else {
      item.classList.add('active');
      if (content) {
        content.style.maxHeight = (content.scrollHeight + 40) + "px";
      }
    }
  }

  const faqQuestions = document.querySelectorAll('.faq-question');
  faqQuestions.forEach(q => {
    q.removeEventListener('click', handleFaqClick);
    q.addEventListener('click', handleFaqClick);
  });

  // Set initial active FAQ height on load if any is active by default
  document.querySelectorAll('.faq-item.active').forEach(activeFaqItem => {
    const content = activeFaqItem.querySelector('.faq-answer');
    if (content) {
      setTimeout(() => {
        content.style.maxHeight = (content.scrollHeight + 40) + "px";
      }, 100);
    }
  });

  /* --- Product Page: Gallery Image Swapping --- */
  if (!document.querySelector('.product-page-section')) {
    const mainImg = document.querySelector('.product-main-img');
    const thumbs = document.querySelectorAll('.product-thumb');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        if (mainImg) {
          mainImg.src = thumb.dataset.full || thumb.src;
        }
      });
    });

    /* --- Product Page: Size tile buttons active toggle --- */
    const sizeTileBtns = document.querySelectorAll('.size-selector-wrapper .size-tile-btn');
    sizeTileBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('disabled')) return;
        sizeTileBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
      });
    });
  }

  /* --- Product Page: Quantity adjustment --- */
  /* Bound once later so the hidden quantity input stays in sync. */

  /* --- Size Guide Modal Toggle --- */
  const sizeGuideTrigger = document.querySelector('.size-guide-trigger');
  const modalOverlay = document.querySelector('.modal-overlay');
  const modalClose = document.querySelector('.modal-close');

  if (sizeGuideTrigger && modalOverlay) {
    sizeGuideTrigger.addEventListener('click', (e) => {
      const href = sizeGuideTrigger.getAttribute('href') || '';
      if (href && href !== '#size-guide' && !href.startsWith('#')) return;
      e.preventDefault();
      modalOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }

  if (modalClose && modalOverlay) {
    modalClose.addEventListener('click', () => {
      modalOverlay.classList.remove('open');
      document.body.style.overflow = '';
    });
    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) {
        modalOverlay.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }

  /* --- Product Specs Accordion Toggle --- */
  const accordionHeaders = document.querySelectorAll('.specs-accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.specs-accordion-item');
      if (!item) return;
      
      const content = item.querySelector('.specs-accordion-content');
      const isActive = item.classList.contains('active');
      
      // Close all accordion items smoothly
      document.querySelectorAll('.specs-accordion-item').forEach(otherItem => {
        otherItem.classList.remove('active');
        const otherContent = otherItem.querySelector('.specs-accordion-content');
        if (otherContent) {
          otherContent.style.maxHeight = '0px';
          otherContent.style.opacity = '0';
        }
      });
      
      if (!isActive && content) {
        item.classList.add('active');
        content.style.opacity = '1';
        content.style.maxHeight = (content.scrollHeight + 40) + "px";
      }
    });
  });

  // Set initial active accordion height on load
  const activeAccordionItem = document.querySelector('.specs-accordion-item.active');
  if (activeAccordionItem) {
    const content = activeAccordionItem.querySelector('.specs-accordion-content');
    if (content) {
      setTimeout(() => {
        content.style.opacity = '1';
        content.style.maxHeight = (content.scrollHeight + 40) + "px";
      }, 120);
    }
  }

  /* --- Pincode Checker Simulation --- */
  const pincodeCheckBtn = document.querySelector('.pincode-check-btn');
  const pincodeInput = document.querySelector('.pincode-input');
  const pincodeResult = document.querySelector('.pincode-result');

  if (pincodeCheckBtn && pincodeInput && pincodeResult) {
    pincodeCheckBtn.addEventListener('click', () => {
      const pin = pincodeInput.value.trim();
      
      // Simple Indian pincode regex: 6 digits
      if (/^[1-9][0-9]{5}$/.test(pin)) {
        pincodeResult.className = 'pincode-result pincode-success';
        pincodeResult.innerHTML = `✓ Delivery available. Free shipping included. Expected delivery by Tuesday.`;
      } else {
        pincodeResult.className = 'pincode-result pincode-error';
        pincodeResult.innerHTML = `✗ Please enter a valid 6-digit postal code.`;
      }
    });
    
    pincodeInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        pincodeCheckBtn.click();
      }
    });
  }

  /* --- Contact form: native Shopify submit (no fake intercept) --- */
  const contactForm = document.querySelector('.contact-form-panel form');
  if (contactForm && !SHOPIFY_CART) {
    const successMsg = document.querySelector('.contact-success-msg');
    contactForm.addEventListener('submit', (e) => {
      e.preventDefault();
      if (successMsg) {
        contactForm.style.display = 'none';
        successMsg.style.display = 'block';
      }
    });
  }

  /* --- Testimonials Typographic Carousel --- */
  const testimonialsSection = document.getElementById('testimonials');
  if (testimonialsSection) {
    const slides = testimonialsSection.querySelectorAll('.testimonial-slide');
    const dots = testimonialsSection.querySelectorAll('.dot');
    const prevBtn = testimonialsSection.querySelector('.carousel-prev');
    const nextBtn = testimonialsSection.querySelector('.carousel-next');
    let currentIndex = 0;
    let autoplayInterval;

    function showSlide(index) {
      if (index >= slides.length) index = 0;
      if (index < 0) index = slides.length - 1;
      currentIndex = index;

      slides.forEach((slide, i) => {
        if (i === currentIndex) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });

      dots.forEach((dot, i) => {
        if (i === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    function nextSlide() {
      showSlide(currentIndex + 1);
    }

    function prevSlide() {
      showSlide(currentIndex - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayInterval = setInterval(nextSlide, 6000);
    }

    function stopAutoplay() {
      if (autoplayInterval) clearInterval(autoplayInterval);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        startAutoplay();
      });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        showSlide(i);
        startAutoplay();
      });
    });

    // Start
    showSlide(0);
    startAutoplay();
  }

  /* --- Enhanced Universal Scroll Reveal & Section-Wise Animation Engine --- */
  const initScrollAnimations = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll('.animate-on-scroll, .fade-in, .fade-up, .fade-zoom, .fade-left, .fade-right, .section-reveal').forEach((el) => {
        el.classList.add('in-view');
      });
      return;
    }

    // Enable site-animated styling
    document.body.classList.add('site-animated');

    // Make sure hero, header, and top banners remain instantly visible without layout shifts
    document.querySelectorAll('.hero-section, .hero-video-section, .page-hero-banner, .about-banner-container, .impact-banner-container, .shop-banner-container, .policy-section, .site-header, .announcement-bar').forEach((el) => {
      el.classList.remove('animate-on-scroll', 'fade-up', 'fade-in', 'section-reveal');
      el.classList.add('in-view');
    });

    // 1. Observe Sections for Section-Wise Entrance across Homepage & All Pages
    const sectionsToObserve = document.querySelectorAll(
      'main > section:not(.hero-video-section):not(.hero-section):not(.about-banner-container):not(.shop-banner-container), ' +
      '.section-padding, .skin-awareness-section, .refuse-editorial-section, .impact-video-section, ' +
      '.collection-list-section, .featured-products-slider-section, .founders-note-section, .material-story-section, ' +
      '#faqs, .about-zigzag-section, .contact-section, .newsletter-section, .the-feel-section, .product-sustainability-section, .product-media-showcase-section, .product-image-showcase-section, .product-video-showcase-section, .our-commitment-section'
    );

    if ('IntersectionObserver' in window && sectionsToObserve.length > 0) {
      const sectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const sec = entry.target;
            sec.classList.add('in-view');

            // Stagger FAQ accordion items if present in section
            const faqItems = sec.querySelectorAll('.faq-item');
            if (faqItems.length > 0) {
              faqItems.forEach((faq, i) => {
                faq.style.setProperty('--faq-delay', `${Math.min(i * 0.08, 0.4)}s`);
                faq.classList.add('is-revealed');
              });
            }

            sectionObserver.unobserve(sec);
          }
        });
      }, {
        threshold: 0.06,
        rootMargin: '0px 0px -40px 0px'
      });

      sectionsToObserve.forEach(sec => {
        sec.classList.add('section-reveal');
        sectionObserver.observe(sec);
      });
    } else {
      sectionsToObserve.forEach(sec => sec.classList.add('in-view'));
    }

    // 2. Observe any elements explicitly tagged with animation classes
    const animElements = document.querySelectorAll('.animate-on-scroll, .fade-in, .fade-up, .fade-zoom, .fade-left, .fade-right');
    if ('IntersectionObserver' in window && animElements.length > 0) {
      const elObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            elObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -40px 0px'
      });

      animElements.forEach(el => elObserver.observe(el));
    } else {
      animElements.forEach(el => el.classList.add('in-view'));
    }
  };

  initScrollAnimations();

  /* --- Footprint Infographic Lightbox --- */
  const footprintImages = Array.from(document.querySelectorAll('.footprint-img'));
  const lightboxModal = document.getElementById('footprint-lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxClose = document.querySelector('.lightbox-close');
  const lightboxPrev = document.querySelector('.lightbox-prev');
  const lightboxNext = document.querySelector('.lightbox-next');
  
  if (footprintImages.length && lightboxModal && lightboxImg) {
    let currentIndex = 0;
    
    function showImage(index) {
      currentIndex = index;
      const img = footprintImages[currentIndex];
      lightboxImg.src = img.src;
      lightboxImg.alt = img.alt;
    }
    
    footprintImages.forEach((img, index) => {
      img.addEventListener('click', () => {
        showImage(index);
        lightboxModal.classList.add('open');
        document.body.style.overflow = 'hidden';
      });
    });
    
    function closeLightbox() {
      lightboxModal.classList.remove('open');
      document.body.style.overflow = '';
    }
    
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    
    lightboxModal.addEventListener('click', (e) => {
      if (e.target === lightboxModal || e.target.classList.contains('lightbox-content')) {
        closeLightbox();
      }
    });
    
    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', (e) => {
        e.stopPropagation();
        let index = currentIndex - 1;
        if (index < 0) index = footprintImages.length - 1;
        showImage(index);
      });
    }
    
    if (lightboxNext) {
      lightboxNext.addEventListener('click', (e) => {
        e.stopPropagation();
        let index = currentIndex + 1;
        if (index >= footprintImages.length) index = 0;
        showImage(index);
      });
    }
    
    // Keyboard Navigation
    document.addEventListener('keydown', (e) => {
      if (!lightboxModal.classList.contains('open')) return;
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        lightboxPrev?.click();
      } else if (e.key === 'ArrowRight') {
        lightboxNext?.click();
      }
    });
  }

  /* --- Footprint Infographic Slider --- */
  const sliderTrack = document.querySelector('.footprint-slider-track');
  const sliderSlides = document.querySelectorAll('.footprint-slide');
  const sliderDots = document.querySelectorAll('.footprint-dot');
  const sliderPrev = document.querySelector('.footprint-prev');
  const sliderNext = document.querySelector('.footprint-next');
  
  if (sliderTrack && sliderSlides.length > 0) {
    let currentSliderIndex = 0;
    
    function updateSlider(index) {
      if (index >= sliderSlides.length) currentSliderIndex = 0;
      else if (index < 0) currentSliderIndex = sliderSlides.length - 1;
      else currentSliderIndex = index;
      
      const translation = -currentSliderIndex * 100;
      sliderTrack.style.transform = `translate3d(${translation}%, 0, 0)`;
      
      sliderSlides.forEach((slide, i) => {
        if (i === currentSliderIndex) {
          slide.classList.add('active');
        } else {
          slide.classList.remove('active');
        }
      });
      
      sliderDots.forEach((dot, i) => {
        if (i === currentSliderIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
    
    // Initialize the slider active classes on load
    updateSlider(0);
    
    if (sliderPrev) {
      sliderPrev.addEventListener('click', () => {
        updateSlider(currentSliderIndex - 1);
      });
    }
    
    if (sliderNext) {
      sliderNext.addEventListener('click', () => {
        updateSlider(currentSliderIndex + 1);
      });
    }
    
    sliderDots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        updateSlider(i);
      });
    });
    
    // Add touch support/swipe gestures for mobile
    let startX = 0;
    let isSwiping = false;
    
    sliderTrack.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isSwiping = true;
    }, { passive: true });
    
    sliderTrack.addEventListener('touchmove', (e) => {
      if (!isSwiping) return;
      const diffX = e.touches[0].clientX - startX;
      if (Math.abs(diffX) > 50) {
        if (diffX > 0) {
          updateSlider(currentSliderIndex - 1);
        } else {
          updateSlider(currentSliderIndex + 1);
        }
        isSwiping = false;
      }
    }, { passive: true });
    
    sliderTrack.addEventListener('touchend', () => {
      isSwiping = false;
    });
  }

  /* --- Environmental Footprint Before/After Image Slider --- */
  const beforeAfterSliderInput = document.querySelector('.slider-range-input');
  const beforeAfterSlider = document.querySelector('.before-after-slider');
  
  if (beforeAfterSliderInput && beforeAfterSlider) {
    beforeAfterSliderInput.addEventListener('input', (e) => {
      beforeAfterSlider.style.setProperty('--clip-position', `${e.target.value}%`);
    });
  }

  /* --- Numeric Counter Animation on Scroll --- */
  const initCounterAnimations = () => {
    const counterElements = document.querySelectorAll('.metric-number, .media-split-stat-num');
    if (counterElements.length === 0) return;

    const animateCounter = (el) => {
      if (el.dataset.counterDone === 'true') return;
      const raw = (el.getAttribute('data-target') || el.textContent || '').trim();
      const match = raw.match(/(\d+)/);
      if (!match) return;

      const target = parseFloat(match[1]);
      const decimals = parseInt(el.getAttribute('data-decimals') || '0', 10);
      const prefix = raw.substring(0, match.index);
      const suffix = el.getAttribute('data-suffix') || raw.substring(match.index + match[1].length);
      el.dataset.counterDone = 'true';

      const duration = 1600; // 1.6 seconds smooth easing
      let startTime = null;

      const step = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        const currentValue = easedProgress * target;
        
        let formattedValue = currentValue.toFixed(decimals);
        if (decimals === 0) {
          formattedValue = Math.floor(currentValue).toLocaleString('en-IN');
        } else {
          const parts = formattedValue.split('.');
          parts[0] = parseInt(parts[0], 10).toLocaleString('en-IN');
          formattedValue = parts.join('.');
        }

        el.textContent = prefix + formattedValue + suffix;

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          let finalValue = target.toFixed(decimals);
          if (decimals === 0) {
            finalValue = Math.floor(target).toLocaleString('en-IN');
          } else {
            const parts = finalValue.split('.');
            parts[0] = parseInt(parts[0], 10).toLocaleString('en-IN');
            finalValue = parts.join('.');
          }
          el.textContent = prefix + finalValue + suffix;
        }
      };

      window.requestAnimationFrame(step);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const el = entry.target;
            animateCounter(el);
            observer.unobserve(el);
          }
        });
      }, { threshold: 0.12 });

      counterElements.forEach(el => observer.observe(el));
    } else {
      counterElements.forEach(animateCounter);
    }
  };

  initCounterAnimations();

  /* --- Inject Floating WhatsApp Widget --- */
  const initWhatsAppWidget = () => {
    if (document.querySelector('.whatsapp-float-widget')) return;
    if (window.theme && window.theme.enableWhatsapp === false) return;
    const number = (window.theme && window.theme.whatsapp) ? String(window.theme.whatsapp).replace(/\D/g, '') : '';
    if (!number) return;
    const whatsappHTML = `
      <a href="https://wa.me/${number}?text=Hello%20The%20Unfold%20Arc%2C%20I%20have%20a%20query%20about%20your%20organic%20cotton%20collection." target="_blank" rel="noopener noreferrer" class="whatsapp-float-widget" aria-label="Chat on WhatsApp">
        <div class="whatsapp-float-btn">
          <div class="whatsapp-pulse-ring"></div>
          <span class="whatsapp-notify-badge"></span>
          <svg viewBox="0 0 24 24"><path d="M12.012 2c-5.506 0-9.969 4.463-9.969 9.969 0 1.763.459 3.487 1.33 5.002l-1.373 5.029 5.15-1.35c1.463.797 3.116 1.218 4.862 1.218 5.506 0 9.969-4.463 9.969-9.969s-4.463-9.969-9.969-9.969zm5.828 14.072c-.244.688-1.428 1.313-1.988 1.394-.525.075-1.206.106-1.944-.131-.444-.144-1.013-.331-1.744-.65-3.081-1.338-5.094-4.469-5.247-4.675-.156-.206-1.25-1.662-1.25-3.169 0-1.506.781-2.25 1.062-2.556.281-.306.612-.381.819-.381.206 0 .412.006.594.012.194.006.456-.075.713.544.269.65.919 2.244 1 2.406.081.162.138.356.031.569-.106.213-.162.344-.319.531-.156.188-.331.419-.469.563-.15.156-.306.325-.131.625.175.3.781 1.288 1.675 2.088 1.15 1.025 2.119 1.344 2.419 1.494.3.15.475.125.656-.081.181-.206.775-.906.981-1.219.206-.312.412-.262.694-.156.281.106 1.788.844 2.094 1 .306.156.512.231.588.362.075.131.075.762-.169 1.45z"/></svg>
        </div>
      </a>
    `;
    document.body.insertAdjacentHTML('beforeend', whatsappHTML);
  };

  const searchToggle = document.querySelector('.header-search-toggle');
  const searchOverlay = document.querySelector('.search-overlay');
  const searchClose = document.querySelector('.search-close-btn');
  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('is-open');
      searchOverlay.hidden = false;
      const input = searchOverlay.querySelector('.search-input');
      if (input) input.focus();
    });
    const closeSearch = () => {
      searchOverlay.classList.remove('is-open');
      searchOverlay.hidden = true;
    };
    if (searchClose) searchClose.addEventListener('click', closeSearch);
    searchOverlay.addEventListener('click', (e) => {
      if (e.target === searchOverlay) closeSearch();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeSearch();
    });
  }

  initWhatsAppWidget();

  /* Product page extras matching original HTML class names */
  if (!document.querySelector('.product-page-section')) {
    document.querySelectorAll('.size-tile-btn:not(.disabled)').forEach((btn) => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.size-tile-btn').forEach((b) => b.classList.remove('active'));
        btn.classList.add('active');
        const form = btn.closest('form') || document.querySelector('[data-product-id]');
        if (form && btn.dataset.variantId) form.dataset.productId = btn.dataset.variantId;
        const idInput = document.querySelector('input[name="id"]');
        if (idInput && btn.dataset.variantId) idInput.value = btn.dataset.variantId;
      });
    });

    const htmlQtyMinus = document.querySelector('.product-qty-minus');
    const htmlQtyPlus = document.querySelector('.product-qty-plus');
    const htmlQtyVal = document.querySelector('.product-qty-val');
    if (htmlQtyMinus && htmlQtyPlus && htmlQtyVal) {
      htmlQtyMinus.addEventListener('click', () => {
        const v = Math.max(1, (parseInt(htmlQtyVal.textContent, 10) || 1) - 1);
        htmlQtyVal.textContent = v;
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) qtyInput.value = v;
      });
      htmlQtyPlus.addEventListener('click', () => {
        const v = (parseInt(htmlQtyVal.textContent, 10) || 1) + 1;
        htmlQtyVal.textContent = v;
        const qtyInput = document.querySelector('input[name="quantity"]');
        if (qtyInput) qtyInput.value = v;
      });
    }
  }

  /* --- Collection Grid Filtering & Sorting Engine --- */
  const initCollectionFilters = () => {
    const gridContainer = document.getElementById('CollectionProductGrid');
    if (!gridContainer) return;

    const filterSelects = document.querySelectorAll('.collection-filter-select');
    const categoryPills = document.querySelectorAll('.collection-cat-pill');
    const catSelect = document.querySelector('select[name="filter.category"]');
    const colorSelect = document.querySelector('select[name="filter.color"]');
    const availSelect = document.querySelector('select[name="filter.v.availability"]');
    const priceSelect = document.querySelector('select[name="filter.price_range"]');
    const sortSelect = document.querySelector('select[name="sort_by"]');
    const clearBtn = document.getElementById('CollectionClearFiltersBtn');
    const resetBtn = document.querySelector('.collection-reset-filters-btn');
    const mobileFilterOpenBtn = document.getElementById('MobileFilterOpenBtn');
    const collectionFilterDrawer = document.getElementById('CollectionFilterDrawer');
    const collectionFilterOverlay = document.getElementById('CollectionFilterOverlay');
    const collectionFilterCloseBtn = document.getElementById('CollectionFilterCloseBtn');
    const drawerApplyBtn = document.getElementById('FilterDrawerApplyBtn') || document.querySelector('.filter-drawer-btn-apply');
    const drawerClearBtn = document.getElementById('FilterDrawerClearBtn') || document.querySelector('.filter-drawer-btn-clear');
    const mobileFilterBadge = document.getElementById('MobileFilterBadge');
    const drawerFilterBadge = document.getElementById('FilterDrawerBadge');
    const drawerApplyCount = document.querySelector('.filter-apply-count');

    // Drawer Open / Close Functions with Smooth Easing
    const openFilterDrawer = () => {
      if (!collectionFilterDrawer) return;
      collectionFilterDrawer.classList.add('is-open');
      if (collectionFilterOverlay) collectionFilterOverlay.classList.add('is-open');
      document.body.classList.add('filter-drawer-open');
      if (mobileFilterOpenBtn) mobileFilterOpenBtn.setAttribute('aria-expanded', 'true');
    };

    const closeFilterDrawer = () => {
      if (!collectionFilterDrawer) return;
      collectionFilterDrawer.classList.remove('is-open');
      if (collectionFilterOverlay) collectionFilterOverlay.classList.remove('is-open');
      document.body.classList.remove('filter-drawer-open');
      if (mobileFilterOpenBtn) mobileFilterOpenBtn.setAttribute('aria-expanded', 'false');
    };

    if (mobileFilterOpenBtn) mobileFilterOpenBtn.addEventListener('click', openFilterDrawer);
    if (collectionFilterCloseBtn) collectionFilterCloseBtn.addEventListener('click', closeFilterDrawer);
    if (collectionFilterOverlay) collectionFilterOverlay.addEventListener('click', closeFilterDrawer);

    let activeCategory = '';
    const initialCards = Array.from(gridContainer.querySelectorAll('.product-card'));

    // Helper: Check if a category value has any matches in the current DOM cards
    const checkCategoryMatchesInDOM = (catValue) => {
      if (!catValue) return true;
      const catFull = catValue.toLowerCase();
      const catStem = catFull.replace(/s$/, '');
      return initialCards.some(card => {
        const pType = (card.dataset.productType || '').toLowerCase();
        const pCategories = (card.dataset.productCategories || '').toLowerCase();
        const pTitle = (card.dataset.productName || card.dataset.productTitle || '').toLowerCase();
        return pType.includes(catFull) || (catStem.length > 2 && pType.includes(catStem)) ||
               pCategories.includes(catFull) || (catStem.length > 2 && pCategories.includes(catStem)) ||
               pTitle.includes(catFull) || (catStem.length > 2 && pTitle.includes(catStem));
      });
    };

    // Helper: Handle category selection (navigating to dedicated collection URL if not in current DOM)
    const handleCategorySelection = () => {
      const selectedOption = catSelect ? catSelect.options[catSelect.selectedIndex] : null;
      const targetUrl = selectedOption ? selectedOption.getAttribute('data-url') : '';
      const catVal = (catSelect ? catSelect.value : '') || '';

      const currentPath = window.location.pathname;
      const isSpecificCollection = currentPath.includes('/collections/') && 
                                   !currentPath.endsWith('/collections/all') && 
                                   !currentPath.endsWith('/collections/all/');

      // If user selected "All Categories" on a specific collection page, navigate to /collections/all
      if (isSpecificCollection && !catVal && targetUrl) {
        window.location.href = targetUrl;
        return;
      }

      // If user selected a category that has 0 matching items in the current collection DOM, navigate to that category's URL
      if (isSpecificCollection && catVal && !checkCategoryMatchesInDOM(catVal) && targetUrl) {
        window.location.href = targetUrl;
        return;
      }

      // In-page client-side filter
      activeCategory = catVal;
      categoryPills.forEach(p => {
        const matches = (p.getAttribute('data-category') || '').toLowerCase() === activeCategory.toLowerCase();
        p.classList.toggle('active', matches);
        p.setAttribute('aria-selected', matches ? 'true' : 'false');
      });
      filterProducts();
    };

    // Apply button handler (drawer)
    const applyFiltersAndClose = () => {
      const selectedOption = catSelect ? catSelect.options[catSelect.selectedIndex] : null;
      const targetUrl = selectedOption ? selectedOption.getAttribute('data-url') : '';
      const catVal = (catSelect ? catSelect.value : '') || '';
      const currentPath = window.location.pathname;
      const isSpecificCollection = currentPath.includes('/collections/') && 
                                   !currentPath.endsWith('/collections/all') && 
                                   !currentPath.endsWith('/collections/all/');

      if (isSpecificCollection && !catVal && targetUrl) {
        window.location.href = targetUrl;
        return;
      }

      if (isSpecificCollection && catVal && !checkCategoryMatchesInDOM(catVal) && targetUrl) {
        window.location.href = targetUrl;
        return;
      }

      filterProducts();
      closeFilterDrawer();
      if (window.innerWidth <= 768 && gridContainer) {
        const topPos = gridContainer.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: Math.max(0, topPos), behavior: 'smooth' });
      }
    };

    if (drawerApplyBtn) {
      drawerApplyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        applyFiltersAndClose();
      });
    }

    // Delegated click handler on the drawer for absolute click reliability
    if (collectionFilterDrawer) {
      collectionFilterDrawer.addEventListener('click', (e) => {
        const applyTarget = e.target.closest('#FilterDrawerApplyBtn, .filter-drawer-btn-apply, [data-action="apply-filter"]');
        if (applyTarget) {
          e.preventDefault();
          applyFiltersAndClose();
          return;
        }

        const clearTarget = e.target.closest('#FilterDrawerClearBtn, .filter-drawer-btn-clear');
        if (clearTarget) {
          e.preventDefault();
          resetAllFilters();
          return;
        }

        const closeTarget = e.target.closest('#CollectionFilterCloseBtn, .collection-filter-close-btn');
        if (closeTarget) {
          e.preventDefault();
          closeFilterDrawer();
          return;
        }
      });
    }

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && collectionFilterDrawer && collectionFilterDrawer.classList.contains('is-open')) {
        closeFilterDrawer();
      }
    });

    // Reset all filters function
    const resetAllFilters = () => {
      activeCategory = '';
      if (catSelect) catSelect.value = '';
      if (colorSelect) colorSelect.value = '';
      if (availSelect) availSelect.value = '';
      if (priceSelect) priceSelect.value = '';
      if (sortSelect) sortSelect.value = 'manual';

      categoryPills.forEach(p => {
        const isShopAll = p.getAttribute('data-category') === '';
        p.classList.toggle('active', isShopAll);
        p.setAttribute('aria-selected', isShopAll ? 'true' : 'false');
      });

      filterProducts();
    };

    if (clearBtn) clearBtn.addEventListener('click', resetAllFilters);
    if (resetBtn) resetBtn.addEventListener('click', resetAllFilters);
    if (drawerClearBtn) drawerClearBtn.addEventListener('click', resetAllFilters);

    // Global reset button listener for any dynamic/server reset buttons
    document.addEventListener('click', (e) => {
      if (e.target && e.target.closest('.collection-reset-filters-btn')) {
        e.preventDefault();
        resetAllFilters();
      }
    });

    // Category pills click handler (synced with category dropdown)
    categoryPills.forEach(pill => {
      pill.addEventListener('click', (e) => {
        e.preventDefault();
        const pillCat = pill.getAttribute('data-category') || '';
        if (catSelect) {
          catSelect.value = pillCat;
        }
        handleCategorySelection();
      });
    });

    // Category dropdown change handler (synced with category pills & URL routing)
    if (catSelect) {
      catSelect.addEventListener('change', () => {
        handleCategorySelection();
      });
    }

    const filterProducts = () => {
      const availVal = availSelect ? availSelect.value : '';
      const priceVal = priceSelect ? priceSelect.value : '';
      const colorVal = (colorSelect ? colorSelect.value : '').trim().toLowerCase();
      const sortVal = sortSelect ? sortSelect.value : 'manual';
      const catVal = (catSelect ? catSelect.value : '') || activeCategory;

      const cards = Array.from(gridContainer.querySelectorAll('.product-card'));
      let visibleCount = 0;

      // Check if any filter is active
      const isFiltered = Boolean(availVal || priceVal || colorVal || catVal || (sortVal && sortVal !== 'manual'));
      if (clearBtn) {
        clearBtn.classList.toggle('is-active', isFiltered);
      }

      cards.forEach(card => {
        let isVisible = true;

        // 1. Availability Filter: "1" = In Stock, "0" = Out of Stock
        if (availVal === '1') {
          if (card.dataset.available === 'false') isVisible = false;
        } else if (availVal === '0') {
          if (card.dataset.available === 'true') isVisible = false;
        }

        // 2. Category Filter (Category Dropdown & Category Pills)
        if (catVal && catVal !== '') {
          const pType = (card.dataset.productType || '').toLowerCase();
          const pCategories = (card.dataset.productCategories || '').toLowerCase();
          const pTitle = (card.dataset.productName || card.dataset.productTitle || '').toLowerCase();
          const catFull = catVal.toLowerCase();
          const catStem = catFull.replace(/s$/, '');

          const matchesType = pType.includes(catFull) || (catStem.length > 2 && pType.includes(catStem));
          const matchesCat = pCategories.includes(catFull) || (catStem.length > 2 && pCategories.includes(catStem));
          const matchesTitle = pTitle.includes(catFull) || (catStem.length > 2 && pTitle.includes(catStem));

          if (!matchesType && !matchesCat && !matchesTitle) {
            isVisible = false;
          }
        }

        // 3. Color Filter
        if (colorVal && colorVal !== '') {
          const pColors = (card.dataset.productColors || '').toLowerCase();
          const pTitle = (card.dataset.productName || card.dataset.productTitle || '').toLowerCase();
          if (!pColors.includes(colorVal) && !pTitle.includes(colorVal)) {
            isVisible = false;
          }
        }

        // 4. Dynamic Price Range Filter (e.g. "0-2000", "2000-3000")
        if (priceVal && priceVal !== '') {
          const parts = priceVal.split('-');
          const minP = parseFloat(parts[0]) || 0;
          const maxP = parseFloat(parts[1]) || Infinity;
          const rawPrice = parseInt(card.dataset.priceRaw || '0', 10);
          const priceRupees = rawPrice / 100;

          if (priceRupees < minP || priceRupees > maxP) {
            isVisible = false;
          }
        }

        if (isVisible) {
          card.style.display = 'flex';
          card.style.removeProperty('opacity');
          visibleCount++;
        } else {
          card.style.display = 'none';
          card.classList.remove('is-revealed');
        }
      });

      // 5. Sorting
      if (sortVal && sortVal !== 'manual' && sortVal !== 'best-selling') {
        cards.sort((a, b) => {
          const priceA = parseInt(a.dataset.priceRaw || '0', 10);
          const priceB = parseInt(b.dataset.priceRaw || '0', 10);
          const nameA = (a.dataset.productName || '').toLowerCase();
          const nameB = (b.dataset.productName || '').toLowerCase();

          if (sortVal === 'price-ascending') return priceA - priceB;
          if (sortVal === 'price-descending') return priceB - priceA;
          if (sortVal === 'title-ascending') return nameA.localeCompare(nameB);
          if (sortVal === 'title-descending') return nameB.localeCompare(nameA);
          if (sortVal === 'created-descending') {
            return initialCards.indexOf(b) - initialCards.indexOf(a);
          }
          if (sortVal === 'created-ascending') {
            return initialCards.indexOf(a) - initialCards.indexOf(b);
          }
          return 0;
        });

        cards.forEach(card => gridContainer.appendChild(card));
      } else {
        initialCards.forEach(card => gridContainer.appendChild(card));
      }

      // Update count text
      const countEl = document.querySelector('.visible-count');
      if (countEl) countEl.textContent = visibleCount;

      // Update badge counts (no numbers on apply button)
      let activeFilterCount = 0;
      if (activeCategory || (catSelect && catSelect.value)) activeFilterCount++;
      if (colorVal) activeFilterCount++;
      if (availVal) activeFilterCount++;
      if (priceVal) activeFilterCount++;
      if (sortVal && sortVal !== 'manual' && sortVal !== 'best-selling') activeFilterCount++;

      if (mobileFilterBadge) {
        if (activeFilterCount > 0) {
          mobileFilterBadge.textContent = activeFilterCount;
          mobileFilterBadge.style.display = 'inline-flex';
        } else {
          mobileFilterBadge.style.display = 'none';
        }
      }
      if (drawerFilterBadge) {
        if (activeFilterCount > 0) {
          drawerFilterBadge.textContent = `${activeFilterCount} active`;
          drawerFilterBadge.style.display = 'inline-block';
        } else {
          drawerFilterBadge.style.display = 'none';
        }
      }
      if (drawerApplyCount) {
        drawerApplyCount.textContent = '';
        drawerApplyCount.style.display = 'none';
      }

      // Toggle empty state if no products visible
      let emptyState = gridContainer.querySelector('.collection-empty-state');
      if (!emptyState) {
        emptyState = document.createElement('div');
        emptyState.className = 'collection-empty-state';
        emptyState.style.cssText = 'grid-column: 1/-1; text-align: center; padding: 60px 20px;';
        emptyState.innerHTML = `
          <p style="font-size: 16px; color: var(--color-text-muted); margin-bottom: 20px;">Sorry, this is not available</p>
          <button type="button" class="btn btn-secondary collection-reset-filters-btn">Reset Filters</button>
        `;
        gridContainer.appendChild(emptyState);
      }
      if (emptyState) {
        emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
        const pEl = emptyState.querySelector('p');
        if (pEl) pEl.textContent = 'Sorry, this is not available';
      }

      // Sync wishlist status on all card buttons
      if (window.WishlistApp && typeof window.WishlistApp.syncButtons === 'function') {
        window.WishlistApp.syncButtons();
      }

      // Sync with URL search params
      try {
        const newUrl = new URL(window.location.href);
        if (catVal) newUrl.searchParams.set('filter.category', catVal);
        else newUrl.searchParams.delete('filter.category');

        if (colorVal) newUrl.searchParams.set('filter.color', colorVal);
        else newUrl.searchParams.delete('filter.color');

        if (availVal) newUrl.searchParams.set('filter.v.availability', availVal);
        else newUrl.searchParams.delete('filter.v.availability');

        if (priceVal) newUrl.searchParams.set('filter.price_range', priceVal);
        else newUrl.searchParams.delete('filter.price_range');

        if (sortVal && sortVal !== 'manual' && sortVal !== 'best-selling') newUrl.searchParams.set('sort_by', sortVal);
        else newUrl.searchParams.delete('sort_by');

        window.history.replaceState({}, '', newUrl.toString());
      } catch (err) {}

      // Re-trigger staggered reveal for visible cards when filtered
      if (typeof gridContainer._retriggerReveal === 'function') {
        const visibleCards = cards.filter(c => c.style.display !== 'none');
        gridContainer._retriggerReveal(visibleCards);
      }
    };

    filterSelects.forEach(select => {
      if (select !== catSelect) {
        select.addEventListener('change', () => {
          filterProducts();
        });
      }
    });

    // Check URL Search Params on load (e.g. ?filter.category=Polo or ?filter.color=Black)
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const urlCat = urlParams.get('filter.category') || urlParams.get('category');
      const urlColor = urlParams.get('filter.color') || urlParams.get('color');
      const urlAvail = urlParams.get('filter.v.availability') || urlParams.get('availability');
      const urlPrice = urlParams.get('filter.price_range') || urlParams.get('price_range');
      const urlSort = urlParams.get('sort_by');

      if (urlCat) {
        activeCategory = urlCat;
        if (catSelect) catSelect.value = urlCat;
        categoryPills.forEach(p => {
          const matches = (p.getAttribute('data-category') || '').toLowerCase() === urlCat.toLowerCase();
          p.classList.toggle('active', matches);
          p.setAttribute('aria-selected', matches ? 'true' : 'false');
        });
      } else if (catSelect && catSelect.value) {
        activeCategory = catSelect.value;
      }
      if (urlColor && colorSelect) {
        colorSelect.value = urlColor;
      }
      if (urlAvail && availSelect) {
        availSelect.value = urlAvail;
      }
      if (urlPrice && priceSelect) {
        priceSelect.value = urlPrice;
      }
      if (urlSort && sortSelect) {
        sortSelect.value = urlSort;
      }
    } catch (e) {}

    filterProducts();
  };

  initCollectionFilters();

  /* --- Universal Product & Collection Card Scroll Stagger & Hover Wave Engine --- */
  const initProductGridAnimation = () => {
    const cardContainers = document.querySelectorAll(
      '#CollectionProductGrid, .product-grid, .featured-slider-track, .collection-list-track, .related-slider-track'
    );
    if (!cardContainers.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      cardContainers.forEach(container => {
        container.querySelectorAll('.product-card, .home-product-card, .featured-product-slide, .collection-card-item').forEach(c => {
          c.classList.add('is-revealed');
        });
      });
      return;
    }

    cardContainers.forEach(container => {
      container.classList.add('product-grid--animated');
      const cards = Array.from(
        container.querySelectorAll('.product-card, .home-product-card, .featured-product-slide, .collection-card-item')
      );
      if (!cards.length) return;

      cards.forEach(c => c.classList.add('card-reveal-item'));

      const isMobile = window.innerWidth <= 768;
      const staggerStep = isMobile ? 0.07 : 0.085;

      const cardObserver = new IntersectionObserver((entries) => {
        const intersecting = entries.filter(e => e.isIntersecting);
        if (!intersecting.length) return;

        // Sort intersecting entries visually (top to bottom, left to right) for clean cascade
        intersecting.sort((a, b) => {
          const rectA = a.target.getBoundingClientRect();
          const rectB = b.target.getBoundingClientRect();
          if (Math.abs(rectA.top - rectB.top) > 20) {
            return rectA.top - rectB.top;
          }
          return rectA.left - rectB.left;
        });

        intersecting.forEach((entry, idx) => {
          const card = entry.target;
          const delay = Math.min(idx * staggerStep, 0.45);
          card.style.setProperty('--reveal-delay', `${delay}s`);
          card.style.transitionDelay = `${delay}s`;
          card.classList.add('is-revealed');
          cardObserver.unobserve(card);
        });
      }, {
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.05
      });

      cards.forEach(card => {
        if (!card.classList.contains('is-revealed')) {
          cardObserver.observe(card);
        }
      });

      // Hover One-by-One Wave ("જ્યારે હું હોવર કરું છું ત્યારે પ્રોડક્ટ્સ વન બાય વન શો થવી જોઈએ")
      let isWaveActive = false;
      container.addEventListener('mouseenter', () => {
        if (isWaveActive) return;
        isWaveActive = true;
        const visibleCards = cards.filter(card => {
          if (!card.classList.contains('is-revealed')) return false;
          const r = card.getBoundingClientRect();
          return r.top < window.innerHeight && r.bottom > 0 && r.left < window.innerWidth && r.right > 0;
        });
        if (!visibleCards.length) {
          isWaveActive = false;
          return;
        }

        const waveStep = 75; // 75ms stagger
        visibleCards.forEach((card, idx) => {
          setTimeout(() => {
            card.classList.add('is-hover-wave');
            setTimeout(() => {
              card.classList.remove('is-hover-wave');
            }, 700);
          }, idx * waveStep);
        });

        setTimeout(() => {
          isWaveActive = false;
        }, visibleCards.length * waveStep + 750);
      });

      // Retrigger function for filtering & sorting dynamically
      container._retriggerReveal = (visibleCards) => {
        const mobile = window.innerWidth <= 768;
        const step = mobile ? 0.05 : 0.07;
        visibleCards.forEach((card, idx) => {
          try { cardObserver.unobserve(card); } catch(e) {}
          card.classList.remove('is-revealed');
          const delay = Math.min(idx * step, 0.4);
          card.style.setProperty('--reveal-delay', `${delay}s`);
          card.style.transitionDelay = `${delay}s`;
          void card.offsetWidth;
          card.classList.add('is-revealed');
        });
      };
    });
  };

  initProductGridAnimation();

  document.querySelectorAll('.collection-sort, .filter-select:not(.collection-filter-select)').forEach((select) => {
    select.addEventListener('change', () => {
      if (!SHOPIFY_CART) return;
      const url = new URL(window.location.href);
      if (select.name) url.searchParams.set(select.name, select.value);
      else if (select.dataset.param) url.searchParams.set(select.dataset.param, select.value);
      window.location.href = url.toString();
    });
  });

  // ==========================================================================
  // GLOBAL WISHLIST & WISHLIST DRAWER SYSTEM
  // ==========================================================================
  const WishlistApp = (function() {
    const STORAGE_KEY_IDS = 'tua_wishlist';
    const STORAGE_KEY_DATA = 'tua_wishlist_data';
    const hydratingPids = new Set();

    function getWishlistIds() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY_IDS) || '[]');
      } catch (e) {
        return [];
      }
    }

    function autoRepairWishlist(items) {
      if (!Array.isArray(items)) return [];
      let modified = false;

      items.forEach(item => {
        const pid = String(item.id || '');
        if (!pid) return;

        // 1. Check DOM for matching card or product page
        const card = document.querySelector(`[data-product-id="${pid}"]`) ||
                     document.querySelector(`.product-page-section[data-product-id="${pid}"]`);
        if (card) {
          if (!item.image || item.image === '') {
            const cardImg = card.dataset.productImage || card.querySelector('img')?.src || '';
            if (cardImg) { item.image = cardImg; modified = true; }
          }
          if (!item.title || item.title === 'Selected Staple') {
            const cardTitle = card.dataset.productTitle || card.dataset.productName || card.querySelector('h3, h4, .product-title')?.textContent.trim() || '';
            if (cardTitle) { item.title = cardTitle; modified = true; }
          }
          if (!item.price || item.price === '') {
            const cardPrice = card.dataset.productPrice || card.querySelector('.home-product-card-price, .price, .product-price')?.textContent.trim() || '';
            if (cardPrice) { item.price = cardPrice; modified = true; }
          }
          if (!item.url || item.url === '/collections/all') {
            const cardUrl = card.dataset.productUrl || card.querySelector('a')?.getAttribute('href') || '';
            if (cardUrl) { item.url = cardUrl; modified = true; }
          }
          if (!item.variantId || item.variantId === item.id || !/^\d+$/.test(String(item.variantId))) {
            const cardVid = card.dataset.variantId || card.dataset.currentVariantId;
            if (cardVid && /^\d+$/.test(String(cardVid))) {
              item.variantId = String(cardVid);
              modified = true;
            }
          }
        }

        // 2. If image or variantId still missing and item has a product URL, fetch JSON in background
        const cleanUrl = (item.url || '').split('?')[0];
        if ((!item.image || item.image === '' || !item.variantId || item.variantId === item.id || !/^\d+$/.test(String(item.variantId))) &&
            cleanUrl && cleanUrl !== '/collections/all' && cleanUrl.includes('/products/')) {
          hydrateItemFromJson(item);
        } else if ((!item.image || item.image === '' || !item.variantId || item.variantId === item.id || !/^\d+$/.test(String(item.variantId))) &&
            (!item.url || item.url === '/collections/all') && /^\d+$/.test(pid)) {
          resolveItemFromSearch(item);
        }
      });

      if (modified) {
        try {
          localStorage.setItem(STORAGE_KEY_DATA, JSON.stringify(items));
        } catch (e) {}
      }
      return items;
    }

    async function hydrateItemFromJson(item) {
      const pid = String(item.id || '');
      if (!pid || hydratingPids.has(pid)) return;
      hydratingPids.add(pid);

      try {
        const cleanUrl = (item.url || '').split('?')[0];
        if (!cleanUrl || !cleanUrl.includes('/products/')) return;
        const res = await fetch(`${cleanUrl}.js`);
        if (!res.ok) return;
        const prod = await res.json();
        let changed = false;

        if (!item.image || item.image === '') {
          let img = prod.featured_image || (prod.images && prod.images[0]) || '';
          if (img) {
            if (img.startsWith('//')) img = 'https:' + img;
            item.image = img;
            changed = true;
          }
        }
        if (!item.title || item.title === 'Selected Staple') {
          if (prod.title) { item.title = prod.title; changed = true; }
        }
        if (!item.price && prod.price) {
          item.price = moneyFmt(prod.price);
          changed = true;
        }
        if ((!item.variantId || item.variantId === item.id || !/^\d+$/.test(String(item.variantId))) && prod.variants && prod.variants.length > 0) {
          const avail = prod.variants.find(v => v.available) || prod.variants[0];
          if (avail && avail.id) {
            item.variantId = String(avail.id);
            changed = true;
          }
        }

        if (changed) {
          let currentList = [];
          try { currentList = JSON.parse(localStorage.getItem(STORAGE_KEY_DATA) || '[]'); } catch (e) {}
          const idx = currentList.findIndex(it => String(it.id) === pid);
          if (idx > -1) {
            currentList[idx] = Object.assign({}, currentList[idx], item);
            localStorage.setItem(STORAGE_KEY_DATA, JSON.stringify(currentList));

            // Dynamically update card in open drawer
            const cardEl = document.querySelector(`.wishlist-item-card[data-id="${pid}"]`);
            if (cardEl) {
              const thumbContainer = cardEl.querySelector('.wishlist-item-thumb a');
              if (thumbContainer && item.image) {
                let imgEl = thumbContainer.querySelector('img');
                let placeholderEl = thumbContainer.querySelector('.wishlist-item-thumb-placeholder');
                if (!imgEl) {
                  imgEl = document.createElement('img');
                  imgEl.alt = item.title;
                  imgEl.loading = 'lazy';
                  thumbContainer.prepend(imgEl);
                }
                imgEl.src = item.image;
                imgEl.style.display = 'block';
                if (placeholderEl) placeholderEl.style.display = 'none';
              }
              const titleEl = cardEl.querySelector('.wishlist-item-title a');
              if (titleEl && item.title) titleEl.textContent = item.title;
              const priceEl = cardEl.querySelector('.wishlist-item-price');
              if (priceEl && item.price) priceEl.textContent = item.price;
              const atcBtn = cardEl.querySelector('.btn-wishlist-atc');
              if (atcBtn && item.variantId) atcBtn.dataset.variantId = item.variantId;
            }
          }
        }
      } catch (err) {
        // Silently continue
      }
    }

    async function resolveItemFromSearch(item) {
      const pid = String(item.id || '');
      if (!pid || hydratingPids.has(pid)) return;
      hydratingPids.add(pid);

      try {
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root.replace(/\/$/, '') : '';
        const res = await fetch(`${root}/search/suggest.json?q=${encodeURIComponent(pid)}&resources[type]=product&resources[limit]=4`);
        if (!res.ok) return;
        const data = await res.json();
        const prods = data.resources?.results?.products || data.products || [];
        const match = prods.find(p => String(p.id) === pid) || prods[0];
        if (match) {
          let changed = false;
          if (!item.title || item.title === 'Selected Staple') {
            if (match.title) { item.title = match.title; changed = true; }
          }
          if (match.url) {
            item.url = match.url;
            changed = true;
          }
          if (!item.image || item.image === '') {
            let img = typeof match.image === 'string' ? match.image : (match.image?.url || match.image?.src || match.featured_image || '');
            if (img) {
              if (img.startsWith('//')) img = 'https:' + img;
              item.image = img;
              changed = true;
            }
          }
          if (!item.price && match.price) {
            item.price = moneyFmt(match.price);
            changed = true;
          }

          if (changed) {
            let currentList = [];
            try { currentList = JSON.parse(localStorage.getItem(STORAGE_KEY_DATA) || '[]'); } catch (e) {}
            const idx = currentList.findIndex(it => String(it.id) === pid);
            if (idx > -1) {
              currentList[idx] = Object.assign({}, currentList[idx], item);
              localStorage.setItem(STORAGE_KEY_DATA, JSON.stringify(currentList));
            }
          }

          if (item.url && item.url.includes('/products/')) {
            hydrateItemFromJson(item);
          }
        }
      } catch (err) {
        // Silently continue
      }
    }

    function getWishlistItems() {
      try {
        let stored = JSON.parse(localStorage.getItem(STORAGE_KEY_DATA) || '[]');
        const ids = getWishlistIds();

        if (Array.isArray(stored) && stored.length > 0) {
          ids.forEach(id => {
            if (!stored.some(it => String(it.id) === String(id))) {
              stored.push({
                id: String(id),
                title: 'Selected Staple',
                price: '',
                image: '',
                url: '/collections/all',
                variantId: String(id)
              });
            }
          });
          stored = stored.filter(it => ids.includes(String(it.id)));
        } else if (ids.length > 0) {
          stored = ids.map(id => ({
            id: String(id),
            title: 'Selected Staple',
            price: '',
            image: '',
            url: '/collections/all',
            variantId: String(id)
          }));
        } else {
          return [];
        }

        return autoRepairWishlist(stored);
      } catch (e) {
        return [];
      }
    }

    function saveWishlist(items) {
      try {
        const ids = items.map(it => String(it.id));
        localStorage.setItem(STORAGE_KEY_DATA, JSON.stringify(items));
        localStorage.setItem(STORAGE_KEY_IDS, JSON.stringify(ids));
      } catch (e) {}
      syncBadges();
      syncButtons();
      renderDrawer();
    }

    function syncBadges() {
      const ids = getWishlistIds();
      const count = ids.length;
      document.querySelectorAll('.wishlist-count').forEach(b => {
        if (count > 0) {
          b.textContent = count;
          b.style.display = 'flex';
        } else {
          b.style.display = 'none';
        }
      });
      const drawerCount = document.getElementById('WishlistDrawerHeaderCount');
      if (drawerCount) drawerCount.textContent = count;
    }

    function syncButtons() {
      const ids = getWishlistIds();
      document.querySelectorAll('.home-product-wishlist-btn, .btn-product-wishlist, .product-gallery-wishlist-btn').forEach(btn => {
        const pid = String(btn.dataset.productId || '');
        if (!pid) return;
        const isSaved = ids.includes(pid);
        btn.classList.toggle('is-active', isSaved);
        btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
        btn.setAttribute('title', isSaved ? 'Remove from Wishlist' : 'Add to Wishlist');
      });
    }

    let toastTimer = null;
    function showToast(message, isSuccess = true) {
      let toast = document.querySelector('.wishlist-floating-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.className = 'wishlist-floating-toast';
        document.body.appendChild(toast);
      }
      toast.innerHTML = `<span class="toast-icon">${isSuccess ? '✓' : '✕'}</span><span>${message}</span>`;
      toast.classList.add('is-visible');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(() => {
        toast.classList.remove('is-visible');
      }, 3000);
    }

    function toggleItem(productData) {
      let items = getWishlistItems();
      const pid = String(productData.id);
      const existingIdx = items.findIndex(it => String(it.id) === pid);

      if (existingIdx > -1) {
        items.splice(existingIdx, 1);
        saveWishlist(items);
        showToast('Removed from your wishlist', false);
      } else {
        let img = (productData.image || '').trim();
        if (img.startsWith('//')) img = 'https:' + img;
        items.unshift({
          id: pid,
          title: productData.title || 'Selected Staple',
          price: productData.price || '',
          image: img,
          url: productData.url || '/collections/all',
          variantId: productData.variantId || pid
        });
        saveWishlist(items);
        showToast('Saved to your wishlist', true);
      }
    }

    function removeItem(id) {
      let items = getWishlistItems();
      items = items.filter(it => String(it.id) !== String(id));
      saveWishlist(items);
      showToast('Removed from your wishlist', false);
    }

    function openDrawer() {
      renderDrawer();
      const drawer = document.getElementById('WishlistDrawer');
      const overlay = document.getElementById('WishlistDrawerOverlay');
      if (drawer) drawer.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      const drawer = document.getElementById('WishlistDrawer');
      const overlay = document.getElementById('WishlistDrawerOverlay');
      if (drawer) drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    async function addWishlistItemToCart(item, btn) {
      btn.disabled = true;
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';

      let targetVariantId = item.variantId;
      const isNumeric = targetVariantId && /^\d+$/.test(String(targetVariantId).trim());

      // If variantId is not numeric or matches the product ID, resolve valid variant from product JSON
      if (!isNumeric || String(targetVariantId) === String(item.id)) {
        const cleanUrl = (item.url || '').split('?')[0];
        if (cleanUrl && cleanUrl.includes('/products/')) {
          try {
            const prodRes = await fetch(`${cleanUrl}.js`);
            if (prodRes.ok) {
              const prodData = await prodRes.json();
              const firstAvail = (prodData.variants || []).find(v => v.available) || prodData.variants[0];
              if (firstAvail && firstAvail.id) {
                targetVariantId = String(firstAvail.id);
                item.variantId = targetVariantId;
                btn.dataset.variantId = targetVariantId;

                // Cache resolved variant and image in localStorage
                let allItems = getWishlistItems();
                const idx = allItems.findIndex(it => String(it.id) === String(item.id));
                if (idx > -1) {
                  allItems[idx].variantId = targetVariantId;
                  if (!allItems[idx].image && prodData.featured_image) allItems[idx].image = prodData.featured_image;
                  try {
                    localStorage.setItem(STORAGE_KEY_DATA, JSON.stringify(allItems));
                  } catch (e) {}
                }
              }
            }
          } catch (err) {
            console.warn('Could not resolve variant ID:', err);
          }
        }
      }

      // If still non-numeric, redirect customer to product page to choose size
      if (!targetVariantId || !/^\d+$/.test(String(targetVariantId).trim())) {
        btn.disabled = false;
        btn.textContent = originalText;
        if (item.url && item.url !== '/collections/all') {
          window.location.href = item.url;
          return;
        }
        showToast('Please view product to choose size', false);
        return;
      }

      // Dispatch POST /cart/add.js
      try {
        const addUrl = shopUrl('/cart/add.js');
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: Number(targetVariantId),
            quantity: 1
          })
        });

        if (res.ok) {
          // Meta Pixel AddToCart tracking
          if (typeof window.fbq === 'function') {
            const vId = String(targetVariantId);
            const pId = String(item.id || '');
            const priceVal = parseFloat(String(item.price || 0).replace(/[^\d.]/g, '')) || 0;
            const contentIds = [vId];
            if (pId && pId !== vId) {
              contentIds.push(`shopify_IN_${pId}_${vId}`, `shopify_${pId}_${vId}`, pId);
            }
            window.fbq('track', 'AddToCart', {
              content_name: item.title || '',
              content_ids: contentIds,
              content_type: 'product',
              value: priceVal,
              currency: window.Shopify?.currency?.active || 'INR'
            });
          }

          closeDrawer();
          if (window.theme && typeof window.theme.refreshCart === 'function') {
            await window.theme.refreshCart();
          }
          if (window.theme && typeof window.theme.openCart === 'function') {
            window.theme.openCart();
          }
          showToast('Added to wardrobe!', true);
        } else {
          const errData = await res.json().catch(() => ({}));
          console.warn('Cart add error:', errData);
          if (item.url && item.url !== '/collections/all') {
            window.location.href = item.url;
          } else {
            showToast(errData.description || 'Could not add to cart', false);
          }
        }
      } catch (err) {
        console.error('Wishlist add to cart error:', err);
        showToast('Network error adding to cart', false);
      } finally {
        btn.disabled = false;
        btn.textContent = originalText;
      }
    }

    function renderDrawer() {
      const container = document.getElementById('WishlistItemsContainer');
      if (!container) return;
      const items = getWishlistItems();

      if (items.length === 0) {
        container.innerHTML = `
          <div class="wishlist-empty">
            <svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.2" style="color: var(--color-brand-burgundy, #691b1f); opacity: 0.5;">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
            <p>Your wishlist is currently empty.</p>
            <a href="/collections/all" class="btn btn-secondary" style="margin-top: 16px; border-radius: 24px; padding: 10px 22px; font-size: 0.85rem;">Discover Staples</a>
          </div>
        `;
        return;
      }

      container.innerHTML = items.map(item => {
        let imgSrc = (item.image || '').trim();
        if (imgSrc.startsWith('//')) {
          imgSrc = 'https:' + imgSrc;
        }
        const hasImg = !!imgSrc;
        return `
        <div class="wishlist-item-card" data-id="${item.id}">
          <div class="wishlist-item-thumb">
            <a href="${item.url || '#'}">
              ${hasImg ? `<img src="${imgSrc}" alt="${item.title || 'Product'}" loading="lazy" onerror="this.style.display='none'; if(this.nextElementSibling) this.nextElementSibling.style.display='flex';" />` : ''}
              <div class="wishlist-item-thumb-placeholder" style="${hasImg ? 'display:none;' : 'display:flex;'}">
                ${item.title ? item.title.charAt(0) : '✦'}
              </div>
            </a>
          </div>
          <div class="wishlist-item-info">
            <h4 class="wishlist-item-title"><a href="${item.url || '#'}">${item.title || 'Selected Staple'}</a></h4>
            <div class="wishlist-item-price">${item.price || ''}</div>
            <div class="wishlist-item-actions">
              <button type="button" class="btn-wishlist-atc" data-variant-id="${item.variantId || item.id}">Add to Bag</button>
              <button type="button" class="btn-wishlist-remove" data-id="${item.id}" aria-label="Remove item">✕ Remove</button>
            </div>
          </div>
        </div>
      `;
      }).join('');

      // Wire up Add to Cart buttons inside wishlist drawer
      container.querySelectorAll('.btn-wishlist-atc').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          e.preventDefault();
          const card = btn.closest('.wishlist-item-card');
          const itemId = card ? card.dataset.id : '';
          const currentList = getWishlistItems();
          const currentItem = currentList.find(it => String(it.id) === String(itemId)) || {
            id: itemId,
            variantId: btn.dataset.variantId,
            url: card?.querySelector('a')?.getAttribute('href')
          };
          await addWishlistItemToCart(currentItem, btn);
        });
      });

      // Wire up Remove buttons inside wishlist drawer
      container.querySelectorAll('.btn-wishlist-remove').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          removeItem(btn.dataset.id);
        });
      });
    }

    // Initialize events
    function init() {
      syncBadges();
      syncButtons();

      // Open drawer on header wishlist click
      document.querySelectorAll('.header-wishlist-toggle').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          openDrawer();
        });
      });

      // Close drawer
      const closeBtn = document.getElementById('WishlistCloseBtn');
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

      const overlay = document.getElementById('WishlistDrawerOverlay');
      if (overlay) overlay.addEventListener('click', closeDrawer);

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeDrawer();
      });

      // Global delegation for wishlist buttons
      document.addEventListener('click', (e) => {
        const btn = e.target.closest('.home-product-wishlist-btn, .btn-product-wishlist, .product-gallery-wishlist-btn');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();

        const card = btn.closest('.home-product-card, .product-page-section');
        const pid = btn.dataset.productId || (card && (card.dataset.productId || card.dataset.currentVariantId));
        if (!pid) return;

        const title = btn.dataset.productTitle || (card && (card.dataset.productTitle || card.dataset.productName)) || '';
        const price = btn.dataset.productPrice || (card && card.dataset.productPrice) || '';
        let image = btn.dataset.productImage || (card && card.dataset.productImage) || '';
        if (!image && card) {
          const imgEl = card.querySelector('img');
          if (imgEl && imgEl.src) image = imgEl.src;
        }
        const url = btn.dataset.productUrl || (card && card.dataset.productUrl) || '';
        const variantId = btn.dataset.variantId || (card && (card.dataset.variantId || card.dataset.currentVariantId)) || pid;

        toggleItem({ id: pid, title, price, image, url, variantId });
      });
    }

    return {
      init,
      toggleItem,
      removeItem,
      openDrawer,
      closeDrawer,
      syncBadges,
      syncButtons,
      showToast,
      getWishlistIds,
      getWishlistItems,
      renderDrawer
    };
  })();

  WishlistApp.init();
  window.WishlistApp = WishlistApp;

  /* --- Dynamic Customer Account State & Dropdown Engine --- */
  function initCustomerAccountState() {
    const dropdownEl = document.querySelector('.header-account-dropdown');
    const loginLink = document.querySelector('.header-account-login-link');
    const nameSpan = document.querySelector('.header-account-name');

    const mobileUserBox = document.querySelector('.mobile-nav-account-user');
    const mobileLoginLink = document.querySelector('.mobile-nav-login-link');
    const mobileNameSpan = document.querySelector('.mobile-nav-user-name');

    function formatCustomerGreeting(name) {
      if (!name) return 'Account';
      let clean = name.trim();
      if (!clean || clean.toLowerCase() === 'account') return 'Account';
      clean = clean.replace(/^hello,?\s*/i, '').trim();
      return clean ? 'Hello, ' + clean : 'Account';
    }

    function showLoggedIn(name) {
      const displayName = formatCustomerGreeting(name);
      if (nameSpan) nameSpan.textContent = displayName;
      if (mobileNameSpan) mobileNameSpan.textContent = displayName;
      if (dropdownEl) dropdownEl.style.display = '';
      if (loginLink) loginLink.style.display = 'none';
      if (mobileUserBox) mobileUserBox.style.display = '';
      if (mobileLoginLink) mobileLoginLink.style.display = 'none';
    }

    function showLoggedOut() {
      if (dropdownEl) dropdownEl.style.display = 'none';
      if (loginLink) loginLink.style.display = '';
      if (mobileUserBox) mobileUserBox.style.display = 'none';
      if (mobileLoginLink) mobileLoginLink.style.display = '';
    }

    // Check if we are currently on the account page itself
    const currentPath = window.location.pathname;
    if (currentPath.endsWith('/account') || currentPath.endsWith('/account/')) {
      const localDataEl = document.querySelector('#customer-account-data');
      if (localDataEl) {
        const localName = (localDataEl.getAttribute('data-customer-first-name') || localDataEl.getAttribute('data-customer-name') || '').trim();
        if (localName) {
          const cleanLocalName = localName.replace(/^hello,?\s*/i, '').trim();
          sessionStorage.setItem('tua_customer_name', cleanLocalName);
          showLoggedIn(cleanLocalName);
        }
      }
    }

    // 1. Check if Liquid rendered customer on this page (Desktop or Mobile)
    const headerContainer = document.querySelector('.header-account-container');
    const mobileContainer = document.querySelector('.mobile-nav-account-footer');
    const isLiquidLoggedIn = (headerContainer && headerContainer.getAttribute('data-customer-logged-in') === 'true') ||
                             (mobileContainer && mobileContainer.getAttribute('data-customer-logged-in') === 'true') ||
                             Boolean(window.theme && window.theme.customer && (window.theme.customer.firstName || window.theme.customer.name));

    if (isLiquidLoggedIn) {
      let customerName = (window.theme && window.theme.customer && (window.theme.customer.firstName || window.theme.customer.name)) ||
                         (headerContainer && headerContainer.getAttribute('data-customer-name')) ||
                         (mobileContainer && mobileContainer.getAttribute('data-customer-name')) ||
                         sessionStorage.getItem('tua_customer_name') || 'Account';
      customerName = customerName.trim().replace(/^hello,?\s*/i, '').trim();
      sessionStorage.setItem('tua_customer_name', customerName);
      showLoggedIn(customerName);
      return; // Already verified by Liquid, do not let async fetch override!
    }

    // Explicit check: If Liquid confirms customer is logged out, clear cache immediately
    if (headerContainer && headerContainer.getAttribute('data-customer-logged-in') === 'false') {
      sessionStorage.removeItem('tua_customer_name');
      showLoggedOut();
      return;
    }

    // 2. Check cached session storage for instant non-flashing hydration
    const cachedName = sessionStorage.getItem('tua_customer_name');
    if (cachedName) {
      showLoggedIn(cachedName);
    }

    // 3. Verify real-time customer session with /account only if not already verified
    const rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const accountUrl = rootPath + 'account';

    fetch(accountUrl, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Cache-Control': 'no-cache' }
    }).then(response => {
      // If redirected to login page, user is definitely logged out
      if (response.redirected && response.url.includes('/login')) {
        sessionStorage.removeItem('tua_customer_name');
        showLoggedOut();
        return;
      }
      if (response.ok && !response.url.includes('/login')) {
        return response.text().then(html => {
          // Verify if response HTML is login page
          if (html.includes('customer_login') || html.includes('login-form')) {
            // Only logout if not on account page
            if (!currentPath.includes('/account')) {
              sessionStorage.removeItem('tua_customer_name');
              showLoggedOut();
            }
          } else {
            // Extract exact customer name from DOM data attribute
            let customerName = '';
            try {
              const parser = new DOMParser();
              const accountDoc = parser.parseFromString(html, 'text/html');
              const dataEl = accountDoc.querySelector('#customer-account-data');
              if (dataEl) {
                customerName = (dataEl.getAttribute('data-customer-first-name') || dataEl.getAttribute('data-customer-name') || '').trim();
              }
              if (!customerName) {
                const nameSpanEl = accountDoc.querySelector('.account-customer-name');
                if (nameSpanEl && nameSpanEl.textContent) {
                  customerName = nameSpanEl.textContent.trim();
                }
              }
            } catch (err) {}

            if (!customerName) {
              const helloMatch = html.match(/Hello\s+([^.<]+)/i);
              if (helloMatch && helloMatch[1]) {
                customerName = helloMatch[1].trim();
              }
            }

            if (!customerName || customerName === 'there') {
              customerName = sessionStorage.getItem('tua_customer_name') || 'Account';
            }

            customerName = customerName.trim().replace(/^hello,?\s*/i, '').trim();
            sessionStorage.setItem('tua_customer_name', customerName);
            showLoggedIn(customerName);
          }
        });
      }
    }).catch(() => {
      // Network failure, keep existing state
    });

    // 4. Handle logout click to clear session storage immediately
    document.addEventListener('click', (e) => {
      const logoutBtn = e.target.closest('a[href*="/account/logout"]');
      if (logoutBtn) {
        sessionStorage.removeItem('tua_customer_name');
        showLoggedOut();
      }
    });

    // 5. Dropdown toggle interaction for click and hover
    if (dropdownEl) {
      const trigger = dropdownEl.querySelector('.dropdown-trigger');
      if (trigger) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          dropdownEl.classList.toggle('is-open');
        });
      }

      dropdownEl.querySelectorAll('.header-account-menu a').forEach((link) => {
        link.addEventListener('click', () => {
          dropdownEl.classList.remove('is-open');
        });
      });
    }

    document.addEventListener('click', (e) => {
      if (dropdownEl && !dropdownEl.contains(e.target)) {
        dropdownEl.classList.remove('is-open');
      }
    });
  }

  initCustomerAccountState();

  // Ensure Judge.me review widgets are initialized across product cards
  if (window.jdgm && typeof window.jdgm.initializeWidgets === 'function') {
    try {
      window.jdgm.initializeWidgets();
    } catch (e) {
      // silent fallback
    }
  }
});
